//background:  linear-gradient(90deg, #1436FF 0%, #396AFC 100%) / Color / #1436FF // text
//background:  linear-gradient(53deg, #FF512F 18.7%, #F09819 85.56%) /; Color / #FF512F // Data
//background:  linear-gradient(59deg, #7F00BA 7.2%, #A811DA 92.35%) / Color / #7F00BA // image
//background:  linear-gradient(53deg, #F857A6 17.43%, #FF5858 84.16%) / Color / #F857A6 // web
//background:  linear-gradient(63deg, #73E49A 14.58%, #1BA049 82.62%) / Color / #73E49A //audio
//background:  linear-gradient(56deg, #2BCCE1 15.56%, #0ED2F7 83.86%) / Color / #2BCCE1 // functions
//background:  linear-gradient(53deg, #FD746C 16.71%, #FE846A 48.74%, #FF9068 80.78%) / Color / #FD746C  // External

import React from 'react';
import { BookOpen, UploadSimple } from '@phosphor-icons/react';

const colors = {
  text: {
    background: 'linear-gradient(90deg, #1436FF 0%, #396AFC 100%)',
    color: '#1436FF',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M16.25 4.375V6.875C16.25 7.04076 16.1842 7.19973 16.0669 7.31694C15.9497 7.43415 15.7908 7.5 15.625 7.5C15.4592 7.5 15.3003 7.43415 15.1831 7.31694C15.0658 7.19973 15 7.04076 15 6.875V5H10.625V15H12.5C12.6658 15 12.8247 15.0658 12.9419 15.1831C13.0592 15.3003 13.125 15.4592 13.125 15.625C13.125 15.7908 13.0592 15.9497 12.9419 16.0669C12.8247 16.1842 12.6658 16.25 12.5 16.25H7.5C7.33424 16.25 7.17527 16.1842 7.05806 16.0669C6.94085 15.9497 6.875 15.7908 6.875 15.625C6.875 15.4592 6.94085 15.3003 7.05806 15.1831C7.17527 15.0658 7.33424 15 7.5 15H9.375V5H5V6.875C5 7.04076 4.93415 7.19973 4.81694 7.31694C4.69973 7.43415 4.54076 7.5 4.375 7.5C4.20924 7.5 4.05027 7.43415 3.93306 7.31694C3.81585 7.19973 3.75 7.04076 3.75 6.875V4.375C3.75 4.20924 3.81585 4.05027 3.93306 3.93306C4.05027 3.81585 4.20924 3.75 4.375 3.75H15.625C15.7908 3.75 15.9497 3.81585 16.0669 3.93306C16.1842 4.05027 16.25 4.20924 16.25 4.375Z"
          fill="#3650DE"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4630_19300"
            x1="6"
            y1="16"
            x2="26"
            y2="16"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1436FF" />
            <stop offset="1" stopColor="#396AFC" />
          </linearGradient>
        </defs>
      </svg>
    ),
    iconFilled: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M16.25 2.5H3.75C3.41848 2.5 3.10054 2.6317 2.86612 2.86612C2.6317 3.10054 2.5 3.41848 2.5 3.75V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8995 17.5 16.5815 17.5 16.25V3.75C17.5 3.41848 17.3683 3.10054 17.1339 2.86612C16.8995 2.6317 16.5815 2.5 16.25 2.5ZM14.375 7.5C14.375 7.66576 14.3092 7.82473 14.1919 7.94194C14.0747 8.05915 13.9158 8.125 13.75 8.125C13.5842 8.125 13.4253 8.05915 13.3081 7.94194C13.1908 7.82473 13.125 7.66576 13.125 7.5V6.875H10.625V13.75H11.875C12.0408 13.75 12.1997 13.8158 12.3169 13.9331C12.4342 14.0503 12.5 14.2092 12.5 14.375C12.5 14.5408 12.4342 14.6997 12.3169 14.8169C12.1997 14.9342 12.0408 15 11.875 15H8.125C7.95924 15 7.80027 14.9342 7.68306 14.8169C7.56585 14.6997 7.5 14.5408 7.5 14.375C7.5 14.2092 7.56585 14.0503 7.68306 13.9331C7.80027 13.8158 7.95924 13.75 8.125 13.75H9.375V6.875H6.875V7.5C6.875 7.66576 6.80915 7.82473 6.69194 7.94194C6.57473 8.05915 6.41576 8.125 6.25 8.125C6.08424 8.125 5.92527 8.05915 5.80806 7.94194C5.69085 7.82473 5.625 7.66576 5.625 7.5V6.25C5.625 6.08424 5.69085 5.92527 5.80806 5.80806C5.92527 5.69085 6.08424 5.625 6.25 5.625H13.75C13.9158 5.625 14.0747 5.69085 14.1919 5.80806C14.3092 5.92527 14.375 6.08424 14.375 6.25V7.5Z"
          fill="url(#paint0_linear_1088_86863)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1088_86863"
            x1="2.5"
            y1="10"
            x2="17.5"
            y2="10"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1436FF" />
            <stop offset="1" stopColor="#396AFC" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  image: {
    background: 'linear-gradient(59deg, #7F00BA 7.2%, #A811DA 92.35%)',
    color: '#7F00BA',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M27 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V25C3 25.5304 3.21071 26.0391 3.58579 26.4142C3.96086 26.7893 4.46957 27 5 27H27C27.5304 27 28.0391 26.7893 28.4142 26.4142C28.7893 26.0391 29 25.5304 29 25V7C29 6.46957 28.7893 5.96086 28.4142 5.58579C28.0391 5.21071 27.5304 5 27 5ZM27 7V19.8438L23.7412 16.5863C23.5555 16.4005 23.335 16.2531 23.0923 16.1526C22.8497 16.052 22.5896 16.0003 22.3269 16.0003C22.0642 16.0003 21.8041 16.052 21.5614 16.1526C21.3187 16.2531 21.0982 16.4005 20.9125 16.5863L18.4125 19.0863L12.9125 13.5863C12.5375 13.2115 12.029 13.0009 11.4987 13.0009C10.9685 13.0009 10.46 13.2115 10.085 13.5863L5 18.6712V7H27ZM5 21.5L11.5 15L21.5 25H5V21.5ZM27 25H24.3288L19.8288 20.5L22.3288 18L27 22.6725V25ZM18 12.5C18 12.2033 18.088 11.9133 18.2528 11.6666C18.4176 11.42 18.6519 11.2277 18.926 11.1142C19.2001 11.0006 19.5017 10.9709 19.7926 11.0288C20.0836 11.0867 20.3509 11.2296 20.5607 11.4393C20.7704 11.6491 20.9133 11.9164 20.9712 12.2074C21.0291 12.4983 20.9993 12.7999 20.8858 13.074C20.7723 13.3481 20.58 13.5824 20.3334 13.7472C20.0867 13.912 19.7967 14 19.5 14C19.1022 14 18.7206 13.842 18.4393 13.5607C18.158 13.2794 18 12.8978 18 12.5Z"
          fill="url(#paint0_linear_1056_22216)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_22216"
            x1="3"
            y1="22.8095"
            x2="26.4902"
            y2="5.95455"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#683BB8" />
            <stop offset="1" stopColor="#A969FD" />
          </linearGradient>
        </defs>
      </svg>
    ),
    iconFilled: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M16.875 3.125H3.125C2.79348 3.125 2.47554 3.2567 2.24112 3.49112C2.0067 3.72554 1.875 4.04348 1.875 4.375V15.625C1.875 15.9565 2.0067 16.2745 2.24112 16.5089C2.47554 16.7433 2.79348 16.875 3.125 16.875H16.875C17.2065 16.875 17.5245 16.7433 17.7589 16.5089C17.9933 16.2745 18.125 15.9565 18.125 15.625V4.375C18.125 4.04348 17.9933 3.72554 17.7589 3.49112C17.5245 3.2567 17.2065 3.125 16.875 3.125ZM12.1875 6.875C12.3729 6.875 12.5542 6.92998 12.7083 7.033C12.8625 7.13601 12.9827 7.28243 13.0536 7.45373C13.1246 7.62504 13.1432 7.81354 13.107 7.9954C13.0708 8.17725 12.9815 8.3443 12.8504 8.47541C12.7193 8.60652 12.5523 8.69581 12.3704 8.73199C12.1885 8.76816 12 8.74959 11.8287 8.67864C11.6574 8.60768 11.511 8.48752 11.408 8.33335C11.305 8.17918 11.25 7.99792 11.25 7.8125C11.25 7.56386 11.3488 7.3254 11.5246 7.14959C11.7004 6.97377 11.9389 6.875 12.1875 6.875ZM3.125 15.625V13.4375L7.1875 9.375L13.4375 15.625H3.125ZM16.875 15.625H15.2055L12.393 12.8125L13.9555 11.25L16.875 14.1703V15.625Z"
          fill="url(#paint0_linear_1088_86623)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1088_86623"
            x1="1.875"
            y1="14.256"
            x2="16.5564"
            y2="3.72159"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#683BB8" />
            <stop offset="1" stopColor="#A969FD" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  audio: {
    background: 'linear-gradient(63deg, #73E49A 14.58%, #1BA049 82.62%)',
    color: '#73E49A',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M19.4387 3.10129C19.2706 3.01935 19.0828 2.98622 18.8968 3.00566C18.7107 3.02511 18.5338 3.09635 18.3862 3.21129L9.65625 10H4C3.46957 10 2.96086 10.2108 2.58579 10.5858C2.21071 10.9609 2 11.4696 2 12V20C2 20.5305 2.21071 21.0392 2.58579 21.4143C2.96086 21.7893 3.46957 22 4 22H9.65625L18.3862 28.7888C18.534 28.9036 18.711 28.9747 18.8971 28.994C19.0832 29.0132 19.271 28.9799 19.4391 28.8977C19.6072 28.8155 19.7489 28.6879 19.8481 28.5292C19.9472 28.3705 19.9999 28.1872 20 28V4.00004C20 3.8127 19.9474 3.62912 19.8482 3.47022C19.749 3.31132 19.6071 3.18349 19.4387 3.10129ZM18 25.955L10.6138 20.2113C10.4386 20.0741 10.2225 19.9997 10 20H4V12H10C10.2225 12.0004 10.4386 11.926 10.6138 11.7888L18 6.04504V25.955ZM25 13V19C25 19.2653 24.8946 19.5196 24.7071 19.7071C24.5196 19.8947 24.2652 20 24 20C23.7348 20 23.4804 19.8947 23.2929 19.7071C23.1054 19.5196 23 19.2653 23 19V13C23 12.7348 23.1054 12.4805 23.2929 12.2929C23.4804 12.1054 23.7348 12 24 12C24.2652 12 24.5196 12.1054 24.7071 12.2929C24.8946 12.4805 25 12.7348 25 13ZM29 11V21C29 21.2653 28.8946 21.5196 28.7071 21.7071C28.5196 21.8947 28.2652 22 28 22C27.7348 22 27.4804 21.8947 27.2929 21.7071C27.1054 21.5196 27 21.2653 27 21V11C27 10.7348 27.1054 10.4805 27.2929 10.2929C27.4804 10.1054 27.7348 10 28 10C28.2652 10 28.5196 10.1054 28.7071 10.2929C28.8946 10.4805 29 10.7348 29 11Z"
          fill="url(#paint0_linear_1056_24276)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_24276"
            x1="6.725"
            y1="26.7244"
            x2="28.6558"
            y2="15.3368"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#73E49A" />
            <stop offset="0.989583" stopColor="#3FC36D" />
          </linearGradient>
        </defs>
      </svg>
    ),
    iconFilled: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M12.5 2.49953V17.4995C12.4999 17.6165 12.467 17.7311 12.405 17.8302C12.3431 17.9294 12.2545 18.0092 12.1495 18.0606C12.0444 18.1119 11.927 18.1328 11.8107 18.1207C11.6944 18.1087 11.5837 18.0643 11.4914 17.9925L6.03516 13.7495H2.5C2.16848 13.7495 1.85054 13.6178 1.61612 13.3834C1.3817 13.149 1.25 12.8311 1.25 12.4995V7.49953C1.25 7.16801 1.3817 6.85007 1.61612 6.61565C1.85054 6.38123 2.16848 6.24953 2.5 6.24953H6.03516L11.4914 2.00656C11.5837 1.93479 11.6944 1.89035 11.8107 1.87832C11.927 1.86628 12.0444 1.88713 12.1495 1.93848C12.2545 1.98984 12.3431 2.06964 12.405 2.16882C12.467 2.268 12.4999 2.38258 12.5 2.49953ZM15 7.49953C14.8342 7.49953 14.6753 7.56538 14.5581 7.68259C14.4408 7.7998 14.375 7.95877 14.375 8.12453V11.8745C14.375 12.0403 14.4408 12.1993 14.5581 12.3165C14.6753 12.4337 14.8342 12.4995 15 12.4995C15.1658 12.4995 15.3247 12.4337 15.4419 12.3165C15.5592 12.1993 15.625 12.0403 15.625 11.8745V8.12453C15.625 7.95877 15.5592 7.7998 15.4419 7.68259C15.3247 7.56538 15.1658 7.49953 15 7.49953Z"
          fill="url(#paint0_linear_1088_86824)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1088_86824"
            x1="3.76562"
            y1="16.7023"
            x2="16.164"
            y2="11.2181"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#73E49A" />
            <stop offset="0.989583" stopColor="#3FC36D" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  data: {
    background: 'linear-gradient(53deg, #FF512F 18.7%, #F09819 85.56%)',
    color: '#FF512F',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M16 3C9.27125 3 4 6.075 4 10V22C4 25.925 9.27125 29 16 29C22.7288 29 28 25.925 28 22V10C28 6.075 22.7288 3 16 3ZM26 16C26 17.2025 25.015 18.4288 23.2987 19.365C21.3662 20.4188 18.7738 21 16 21C13.2262 21 10.6337 20.4188 8.70125 19.365C6.985 18.4288 6 17.2025 6 16V13.92C8.1325 15.795 11.7787 17 16 17C20.2213 17 23.8675 15.79 26 13.92V16ZM8.70125 6.635C10.6337 5.58125 13.2262 5 16 5C18.7738 5 21.3662 5.58125 23.2987 6.635C25.015 7.57125 26 8.7975 26 10C26 11.2025 25.015 12.4288 23.2987 13.365C21.3662 14.4187 18.7738 15 16 15C13.2262 15 10.6337 14.4187 8.70125 13.365C6.985 12.4288 6 11.2025 6 10C6 8.7975 6.985 7.57125 8.70125 6.635ZM23.2987 25.365C21.3662 26.4188 18.7738 27 16 27C13.2262 27 10.6337 26.4188 8.70125 25.365C6.985 24.4287 6 23.2025 6 22V19.92C8.1325 21.795 11.7787 23 16 23C20.2213 23 23.8675 21.79 26 19.92V22C26 23.2025 25.015 24.4287 23.2987 25.365Z"
          fill="url(#paint0_linear_1056_25983)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_25983"
            x1="8"
            y1="23.4286"
            x2="27.0053"
            y2="10.3407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF512F" />
            <stop offset="1" stopColor="#F09819" />
          </linearGradient>
        </defs>
      </svg>
    ),
    iconFilled: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 1.875C5.79453 1.875 2.5 3.79688 2.5 6.25V13.75C2.5 16.2031 5.79453 18.125 10 18.125C14.2055 18.125 17.5 16.2031 17.5 13.75V6.25C17.5 3.79688 14.2055 1.875 10 1.875ZM16.25 10C16.25 10.7516 15.6344 11.518 14.5617 12.1031C13.3539 12.7617 11.7336 13.125 10 13.125C8.26641 13.125 6.64609 12.7617 5.43828 12.1031C4.36563 11.518 3.75 10.7516 3.75 10V8.7C5.08281 9.87187 7.36172 10.625 10 10.625C12.6383 10.625 14.9172 9.86875 16.25 8.7V10ZM14.5617 15.8531C13.3539 16.5117 11.7336 16.875 10 16.875C8.26641 16.875 6.64609 16.5117 5.43828 15.8531C4.36563 15.268 3.75 14.5016 3.75 13.75V12.45C5.08281 13.6219 7.36172 14.375 10 14.375C12.6383 14.375 14.9172 13.6187 16.25 12.45V13.75C16.25 14.5016 15.6344 15.268 14.5617 15.8531Z"
          fill="url(#paint0_linear_1088_86761)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1088_86761"
            x1="5"
            y1="14.6429"
            x2="16.8783"
            y2="6.46294"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF512F" />
            <stop offset="1" stopColor="#F09819" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  web: {
    background: 'linear-gradient(53deg, #F857A6 17.43%, #FF5858 84.16%)',
    color: '#F857A6',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M16 3C13.4288 3 10.9154 3.76244 8.77759 5.1909C6.63975 6.61935 4.97351 8.64968 3.98957 11.0251C3.00563 13.4006 2.74819 16.0144 3.2498 18.5362C3.75141 21.0579 4.98953 23.3743 6.80762 25.1924C8.6257 27.0105 10.9421 28.2486 13.4638 28.7502C15.9856 29.2518 18.5995 28.9944 20.9749 28.0104C23.3503 27.0265 25.3807 25.3603 26.8091 23.2224C28.2376 21.0846 29 18.5712 29 16C28.9964 12.5533 27.6256 9.24882 25.1884 6.81163C22.7512 4.37445 19.4467 3.00364 16 3ZM26.9538 15H21.975C21.7988 11.4425 20.6913 8.06625 18.835 5.375C21.009 5.95867 22.9523 7.1938 24.4036 8.91443C25.855 10.6351 26.7449 12.7587 26.9538 15ZM16 26.9862C13.6588 24.4525 12.2388 20.8612 12.0288 17H19.9713C19.7613 20.8587 18.3413 24.4525 16 26.9862ZM12.0288 15C12.2388 11.1412 13.6538 7.5475 16 5.01375C18.3413 7.5475 19.7613 11.1388 19.9713 15H12.0288ZM13.165 5.375C11.3088 8.06625 10.2013 11.4425 10.025 15H5.04626C5.25511 12.7587 6.14501 10.6351 7.59637 8.91443C9.04773 7.1938 10.991 5.95867 13.165 5.375ZM5.04626 17H10.025C10.2013 20.5575 11.3088 23.9338 13.165 26.625C10.991 26.0413 9.04773 24.8062 7.59637 23.0856C6.14501 21.3649 5.25511 19.2413 5.04626 17ZM18.835 26.625C20.6913 23.93 21.7988 20.5537 21.975 17H26.9538C26.7449 19.2413 25.855 21.3649 24.4036 23.0856C22.9523 24.8062 21.009 26.0413 18.835 26.625Z"
          fill="url(#paint0_linear_1056_24923)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_24923"
            x1="6.61111"
            y1="23.2222"
            x2="26.1111"
            y2="8.77778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F857A6" />
            <stop offset="1" stopColor="#FF5858" />
          </linearGradient>
        </defs>
      </svg>
    ),
    iconFilled: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM16.8461 9.375H13.7344C13.6242 7.15156 12.932 5.04141 11.7719 3.35938C13.1306 3.72417 14.3452 4.49613 15.2523 5.57152C16.1594 6.64691 16.7156 7.97419 16.8461 9.375ZM7.51797 10.625H12.482C12.3508 13.0367 11.4664 15.2828 10 16.8664C8.53672 15.2828 7.64922 13.0367 7.51797 10.625ZM7.51797 9.375C7.64922 6.96328 8.5336 4.71719 10 3.13359C11.4633 4.71719 12.3508 6.96172 12.482 9.375H7.51797ZM11.7719 16.6406C12.932 14.9563 13.6242 12.8461 13.7344 10.625H16.8461C16.7156 12.0258 16.1594 13.3531 15.2523 14.4285C14.3452 15.5039 13.1306 16.2758 11.7719 16.6406Z"
          fill="url(#paint0_linear_1088_87225)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1088_87225"
            x1="4.13194"
            y1="14.5139"
            x2="16.3194"
            y2="5.48611"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F857A6" />
            <stop offset="1" stopColor="#FF5858" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  functions: {
    background: 'linear-gradient(56deg, #2BCCE1 15.56%, #0ED2F7 83.86%)',
    color: '#2BCCE1',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M29 15H26.9538C26.8413 13.75 26.514 12.5287 25.9862 11.39L27.7588 10.3663C27.9885 10.2336 28.1561 10.0152 28.2248 9.75898C28.2935 9.50276 28.2576 9.22974 28.125 9C27.9924 8.77026 27.7739 8.6026 27.5177 8.53392C27.2615 8.46523 26.9885 8.50114 26.7588 8.63375L24.9837 9.65875C24.2586 8.63487 23.3651 7.74137 22.3412 7.01625L23.3662 5.24125C23.4989 5.01151 23.5348 4.73849 23.4661 4.48227C23.3974 4.22605 23.2297 4.00761 23 3.875C22.7703 3.74239 22.4972 3.70648 22.241 3.77517C21.9848 3.84385 21.7664 4.01151 21.6338 4.24125L20.61 6.01375C19.4713 5.48598 18.25 5.15868 17 5.04625V3C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2C15.7348 2 15.4804 2.10536 15.2929 2.29289C15.1054 2.48043 15 2.73478 15 3V5.04625C13.75 5.15868 12.5287 5.48598 11.39 6.01375L10.3663 4.24125C10.3006 4.12749 10.2132 4.02778 10.109 3.94781C10.0048 3.86784 9.88585 3.80917 9.75898 3.77517C9.63211 3.74116 9.49978 3.73247 9.36956 3.7496C9.23933 3.76673 9.11376 3.80934 9 3.875C8.77026 4.00761 8.6026 4.22605 8.53392 4.48227C8.46523 4.73849 8.50114 5.01151 8.63375 5.24125L9.65875 7.01625C8.63487 7.74137 7.74137 8.63487 7.01625 9.65875L5.24125 8.63375C5.01151 8.50114 4.73849 8.46523 4.48227 8.53392C4.22605 8.6026 4.00761 8.77026 3.875 9C3.74239 9.22974 3.70648 9.50276 3.77517 9.75898C3.84385 10.0152 4.01151 10.2336 4.24125 10.3663L6.01375 11.39C5.48598 12.5287 5.15868 13.75 5.04625 15H3C2.73478 15 2.48043 15.1054 2.29289 15.2929C2.10536 15.4804 2 15.7348 2 16C2 16.2652 2.10536 16.5196 2.29289 16.7071C2.48043 16.8946 2.73478 17 3 17H5.04625C5.15868 18.25 5.48598 19.4713 6.01375 20.61L4.24125 21.6338C4.0505 21.7438 3.90139 21.9137 3.81707 22.1171C3.73275 22.3205 3.71794 22.5461 3.77493 22.7588C3.83191 22.9715 3.95752 23.1594 4.13224 23.2935C4.30697 23.4275 4.52104 23.5001 4.74125 23.5C4.91683 23.5005 5.08939 23.4544 5.24125 23.3662L7.01625 22.3412C7.74137 23.3651 8.63487 24.2586 9.65875 24.9837L8.63375 26.7588C8.50114 26.9885 8.46523 27.2615 8.53392 27.5177C8.6026 27.7739 8.77026 27.9924 9 28.125C9.22974 28.2576 9.50276 28.2935 9.75898 28.2248C10.0152 28.1561 10.2336 27.9885 10.3663 27.7588L11.39 25.9862C12.5287 26.514 13.75 26.8413 15 26.9538V29C15 29.2652 15.1054 29.5196 15.2929 29.7071C15.4804 29.8946 15.7348 30 16 30C16.2652 30 16.5196 29.8946 16.7071 29.7071C16.8946 29.5196 17 29.2652 17 29V26.9538C18.25 26.8413 19.4713 26.514 20.61 25.9862L21.6338 27.7588C21.7664 27.9885 21.9848 28.1561 22.241 28.2248C22.4972 28.2935 22.7703 28.2576 23 28.125C23.2297 27.9924 23.3974 27.774 23.4661 27.5177C23.5348 27.2615 23.4989 26.9885 23.3662 26.7588L22.3412 24.9837C23.3651 24.2586 24.2586 23.3651 24.9837 22.3412L26.7588 23.3662C26.8725 23.4319 26.9981 23.4746 27.1283 23.4917C27.2585 23.5089 27.3909 23.5002 27.5177 23.4662C27.6446 23.4321 27.7636 23.3735 27.8677 23.2935C27.9719 23.2135 28.0594 23.1138 28.125 23C28.2578 22.7704 28.2939 22.4975 28.2254 22.2413C28.157 21.9851 27.9896 21.7665 27.76 21.6338L25.9875 20.61C26.5148 19.4712 26.8417 18.25 26.9538 17H29C29.2652 17 29.5196 16.8946 29.7071 16.7071C29.8946 16.5196 30 16.2652 30 16C30 15.7348 29.8946 15.4804 29.7071 15.2929C29.5196 15.1054 29.2652 15 29 15ZM16 7C18.2129 7.00263 20.3474 7.81952 21.9966 9.29493C23.6458 10.7703 24.6944 12.8011 24.9425 15H16.5775L12.395 7.75625C13.5312 7.25687 14.7589 6.99933 16 7ZM7 16C7.00076 14.5902 7.33271 13.2003 7.96909 11.9423C8.60547 10.6843 9.52849 9.59339 10.6637 8.7575L14.845 16L10.6637 23.2425C9.52849 22.4066 8.60547 21.3157 7.96909 20.0577C7.33271 18.7997 7.00076 17.4098 7 16ZM16 25C14.7593 25.0026 13.5317 24.7472 12.395 24.25L16.5775 17H24.9425C24.6944 19.1989 23.6458 21.2297 21.9966 22.7051C20.3474 24.1805 18.2129 24.9974 16 25Z"
          fill="url(#paint0_linear_696_31608)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_696_31608"
            x1="5.62963"
            y1="24.5556"
            x2="27.6667"
            y2="9.77778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2BCCE1" />
            <stop offset="1" stopColor="#0ED2F7" />
          </linearGradient>
        </defs>
      </svg>
    ),
    iconFilled: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M18.125 9.375H17.4734C17.4004 8.48373 17.1669 7.61299 16.7844 6.80469L17.3492 6.47891C17.4928 6.39603 17.5976 6.2595 17.6405 6.09936C17.6835 5.93922 17.661 5.76859 17.5781 5.625C17.4952 5.48141 17.3587 5.37663 17.1986 5.3337C17.0384 5.29077 16.8678 5.31321 16.7242 5.39609L16.1578 5.72344C15.6466 4.99032 15.0097 4.35343 14.2766 3.84219L14.6039 3.27578C14.6868 3.13219 14.7092 2.96156 14.6663 2.80142C14.6234 2.64128 14.5186 2.50476 14.375 2.42188C14.2314 2.33899 14.0608 2.31655 13.9006 2.35948C13.7405 2.40241 13.604 2.50719 13.5211 2.65078L13.1953 3.21563C12.387 2.83308 11.5163 2.59964 10.625 2.52656V1.875C10.625 1.70924 10.5592 1.55027 10.4419 1.43306C10.3247 1.31585 10.1658 1.25 10 1.25C9.83424 1.25 9.67527 1.31585 9.55806 1.43306C9.44085 1.55027 9.375 1.70924 9.375 1.875V2.52656C8.48373 2.59964 7.61299 2.83308 6.80469 3.21563L6.47891 2.65078C6.39603 2.50719 6.2595 2.40241 6.09936 2.35948C5.93922 2.31655 5.76859 2.33899 5.625 2.42188C5.48141 2.50476 5.37663 2.64128 5.3337 2.80142C5.29077 2.96156 5.31321 3.13219 5.39609 3.27578L5.72344 3.84219C4.99032 4.35343 4.35343 4.99032 3.84219 5.72344L3.27578 5.39609C3.20468 5.35506 3.1262 5.32842 3.04481 5.31772C2.96342 5.30701 2.88071 5.31244 2.80142 5.3337C2.64128 5.37663 2.50476 5.48141 2.42188 5.625C2.33899 5.76859 2.31655 5.93922 2.35948 6.09936C2.40241 6.2595 2.50719 6.39603 2.65078 6.47891L3.21563 6.80469C2.83308 7.61299 2.59964 8.48373 2.52656 9.375H1.875C1.70924 9.375 1.55027 9.44085 1.43306 9.55806C1.31585 9.67527 1.25 9.83424 1.25 10C1.25 10.1658 1.31585 10.3247 1.43306 10.4419C1.55027 10.5592 1.70924 10.625 1.875 10.625H2.52656C2.59964 11.5163 2.83308 12.387 3.21563 13.1953L2.65078 13.5211C2.53156 13.5899 2.43837 13.696 2.38567 13.8232C2.33297 13.9503 2.32371 14.0913 2.35933 14.2242C2.39495 14.3572 2.47345 14.4747 2.58265 14.5584C2.69185 14.6422 2.82565 14.6876 2.96328 14.6875C3.07302 14.6878 3.18087 14.659 3.27578 14.6039L3.84219 14.2766C4.35343 15.0097 4.99032 15.6466 5.72344 16.1578L5.39609 16.7242C5.31321 16.8678 5.29077 17.0384 5.3337 17.1986C5.37663 17.3587 5.48141 17.4952 5.625 17.5781C5.76859 17.661 5.93922 17.6835 6.09936 17.6405C6.2595 17.5976 6.39603 17.4928 6.47891 17.3492L6.80469 16.7844C7.61299 17.1669 8.48373 17.4004 9.375 17.4734V18.125C9.375 18.2908 9.44085 18.4497 9.55806 18.5669C9.67527 18.6842 9.83424 18.75 10 18.75C10.1658 18.75 10.3247 18.6842 10.4419 18.5669C10.5592 18.4497 10.625 18.2908 10.625 18.125V17.4734C11.5163 17.4004 12.387 17.1669 13.1953 16.7844L13.5211 17.3492C13.604 17.4928 13.7405 17.5976 13.9006 17.6405C14.0608 17.6835 14.2314 17.661 14.375 17.5781C14.5186 17.4952 14.6234 17.3587 14.6663 17.1986C14.7092 17.0384 14.6868 16.8678 14.6039 16.7242L14.2766 16.1578C15.0097 15.6466 15.6466 15.0097 16.1578 14.2766L16.7242 14.6039C16.7953 14.645 16.8738 14.6716 16.9552 14.6823C17.0366 14.693 17.1193 14.6876 17.1986 14.6664C17.2779 14.6451 17.3522 14.6084 17.4173 14.5584C17.4825 14.5084 17.5371 14.4461 17.5781 14.375C17.6611 14.2315 17.6837 14.0609 17.6409 13.9008C17.5981 13.7407 17.4935 13.6041 17.35 13.5211L16.7852 13.1953C17.1677 12.387 17.4011 11.5163 17.4742 10.625H18.125C18.2908 10.625 18.4497 10.5592 18.5669 10.4419C18.6842 10.3247 18.75 10.1658 18.75 10C18.75 9.83424 18.6842 9.67527 18.5669 9.55806C18.4497 9.44085 18.2908 9.375 18.125 9.375ZM5.625 10C5.62468 9.3379 5.77488 8.68439 6.06425 8.08887C6.35361 7.49336 6.77458 6.97141 7.29531 6.5625L9.27812 10L7.29531 13.4375C6.77458 13.0286 6.35361 12.5066 6.06425 11.9111C5.77488 11.3156 5.62468 10.6621 5.625 10ZM10 14.375C9.44385 14.3756 8.89275 14.2695 8.37656 14.0625L10.3609 10.625H14.3297C14.178 11.6656 13.6572 12.6169 12.8624 13.3053C12.0675 13.9938 11.0516 14.3734 10 14.375ZM10.3609 9.375L8.37656 5.9375C8.99112 5.69199 9.65337 5.5891 10.3134 5.63657C10.9735 5.68405 11.6142 5.88064 12.1873 6.21157C12.7604 6.54249 13.251 6.99912 13.6221 7.54707C13.9932 8.09502 14.2351 8.72001 14.3297 9.375H10.3609Z"
          fill="url(#paint0_linear_1088_87162)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1088_87162"
            x1="3.51852"
            y1="15.3472"
            x2="17.2917"
            y2="6.11111"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2BCCE1" />
            <stop offset="1" stopColor="#0ED2F7" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  external: {
    background:
      'linear-gradient(53deg, #FD746C 16.71%, #FE846A 48.74%, #FF9068 80.78%)',
    color: '#FD746C',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M30.6387 7.58464C29.6825 5.93589 27.1587 5.56464 23.3262 6.50214C21.5519 5.13019 19.4284 4.28336 17.1969 4.05784C14.9654 3.83233 12.7154 4.23718 10.7025 5.22639C8.68955 6.2156 6.99441 7.74953 5.80961 9.65391C4.62481 11.5583 3.99786 13.7568 3.99997 15.9996C4.00013 16.5141 4.0327 17.028 4.09747 17.5384C0.636224 21.1246 0.686224 23.2496 1.36247 24.4146C1.99997 25.5196 3.32997 25.9996 5.07997 25.9996C6.295 25.9745 7.50287 25.8067 8.67872 25.4996C10.4532 26.8703 12.5765 27.7159 14.8074 27.9405C17.0383 28.1651 19.2876 27.7598 21.2997 26.7704C23.3118 25.7811 25.0063 24.2474 26.1906 22.3435C27.375 20.4397 28.0018 18.2418 28 15.9996C28.0002 15.4877 27.9681 14.9763 27.9037 14.4684C29.4662 12.8434 30.5062 11.2996 30.86 9.97839C31.1037 9.06339 31.03 8.25839 30.6387 7.58464ZM16 5.99964C18.2649 6.00196 20.4622 6.77205 22.233 8.18418C24.0038 9.5963 25.2436 11.567 25.75 13.7746C23.6175 15.7821 20.7312 17.8409 17.9912 19.4159C14.5475 21.3921 11.56 22.6246 9.17747 23.2996C7.71007 21.931 6.68869 20.1524 6.2463 18.1951C5.80392 16.2379 5.96103 14.1929 6.69717 12.3262C7.43332 10.4596 8.7144 8.85775 10.3736 7.72935C12.0329 6.60095 13.9934 5.99822 16 5.99964ZM3.09247 23.4109C2.90997 23.0971 3.01122 22.5059 3.36997 21.7859C3.72473 21.1113 4.15635 20.48 4.65622 19.9046C5.15172 21.3403 5.91524 22.6688 6.90622 23.8196C4.74997 24.1821 3.40497 23.9509 3.09247 23.4109ZM16 25.9996C14.3139 26.0013 12.6551 25.5737 11.18 24.7571C13.8876 23.7995 16.5001 22.5918 18.9837 21.1496C21.6812 19.6009 24.0687 17.9221 25.9925 16.2646C25.9212 18.8686 24.8376 21.3422 22.9718 23.1599C21.1059 24.9777 18.6049 25.9964 16 25.9996ZM28.9275 9.46089C28.715 10.2496 28.1537 11.1521 27.3487 12.1021C26.8545 10.6648 26.0909 9.33482 25.0987 8.18339C26.875 7.88964 28.52 7.91214 28.9112 8.58839C29.0237 8.78464 29.03 9.07839 28.9275 9.46089Z"
          fill="url(#paint0_linear_537_24169)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_537_24169"
            x1="3.33336"
            y1="23.4668"
            x2="23.8892"
            y2="4.37212"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0572917" stopColor="#FD746C" />
            <stop offset="0.494792" stopColor="#FE846A" />
            <stop offset="0.932292" stopColor="#FF9068" />
          </linearGradient>
        </defs>
      </svg>
    ),
    iconFilled: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M17.439 9.04262C17.4795 9.36003 17.4999 9.67968 17.5 9.99965C17.5011 11.401 17.1094 12.7747 16.3691 13.9646C15.6289 15.1545 14.5699 16.1131 13.3123 16.7314C12.0547 17.3497 10.649 17.6031 9.25464 17.4627C7.86031 17.3223 6.53327 16.7938 5.4242 15.9372C7.39217 15.4559 9.70702 14.4582 11.8648 13.2184C14.1648 11.8973 16.1062 10.4262 17.439 9.04262ZM19.1492 4.74028C18.5515 3.70981 16.9742 3.47778 14.5789 4.06371C13.4699 3.20625 12.1428 2.67698 10.7481 2.53603C9.35339 2.39509 7.94713 2.64811 6.68905 3.26637C5.43097 3.88463 4.3715 4.84333 3.63101 6.03357C2.89051 7.22381 2.49866 8.59787 2.49998 9.99965C2.50008 10.3212 2.52043 10.6424 2.56092 10.9614C0.39764 13.2028 0.42889 14.5309 0.851546 15.259C1.24998 15.9497 2.08123 16.2497 3.17498 16.2497C3.93438 16.2339 4.68929 16.1291 5.4242 15.9372C5.02123 15.6256 4.65062 15.2744 4.31795 14.8887C2.96717 15.1137 2.13045 14.9668 1.9328 14.6317C1.81873 14.4356 1.88202 14.0661 2.10623 13.6161C2.32794 13.1946 2.59742 12.8001 2.90936 12.4403C2.90972 12.4379 2.90972 12.4356 2.90936 12.4332V12.4395C3.21941 13.3366 3.69657 14.1669 4.31561 14.8864C5.95155 14.6137 8.33827 13.7997 11.2398 12.1325C13.4375 10.8739 15.7812 9.1145 17.093 7.56371C16.7841 6.66538 16.3068 5.83414 15.6867 5.1145L15.6765 5.10278C15.6765 5.10668 15.6836 5.10981 15.6867 5.1145C16.7969 4.9309 17.825 4.94496 18.0695 5.36762C18.1414 5.49028 18.1476 5.67387 18.0812 5.9145C17.9492 6.40746 17.5976 6.97153 17.0945 7.56528C17.2599 8.04517 17.3759 8.54071 17.4406 9.04418C18.4172 8.02856 19.0672 7.06371 19.2883 6.23793C19.4398 5.6645 19.3937 5.16137 19.1492 4.74028Z"
          fill="url(#paint0_linear_1088_87187)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1088_87187"
            x1="2.08336"
            y1="14.6666"
            x2="14.9308"
            y2="2.73233"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0572917" stopColor="#FD746C" />
            <stop offset="0.494792" stopColor="#FE846A" />
            <stop offset="0.932292" stopColor="#FF9068" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  library: {
    background: 'linear-gradient(90deg, #C6A903 0%, #DCC73D 100%)',
    color: '#C6A903',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M17.5 3.75H12.5C12.0149 3.75 11.5364 3.86295 11.1025 4.07991C10.6685 4.29688 10.2911 4.61189 10 5C9.70892 4.61189 9.33147 4.29688 8.89754 4.07991C8.46362 3.86295 7.98514 3.75 7.5 3.75H2.5C2.16848 3.75 1.85054 3.8817 1.61612 4.11612C1.3817 4.35054 1.25 4.66848 1.25 5V15C1.25 15.3315 1.3817 15.6495 1.61612 15.8839C1.85054 16.1183 2.16848 16.25 2.5 16.25H7.5C7.99728 16.25 8.47419 16.4475 8.82583 16.7992C9.17746 17.1508 9.375 17.6277 9.375 18.125C9.375 18.2908 9.44085 18.4497 9.55806 18.5669C9.67527 18.6842 9.83424 18.75 10 18.75C10.1658 18.75 10.3247 18.6842 10.4419 18.5669C10.5592 18.4497 10.625 18.2908 10.625 18.125C10.625 17.6277 10.8225 17.1508 11.1742 16.7992C11.5258 16.4475 12.0027 16.25 12.5 16.25H17.5C17.8315 16.25 18.1495 16.1183 18.3839 15.8839C18.6183 15.6495 18.75 15.3315 18.75 15V5C18.75 4.66848 18.6183 4.35054 18.3839 4.11612C18.1495 3.8817 17.8315 3.75 17.5 3.75ZM7.5 15H2.5V5H7.5C7.99728 5 8.47419 5.19754 8.82583 5.54917C9.17746 5.90081 9.375 6.37772 9.375 6.875V15.625C8.83458 15.2183 8.17633 14.9989 7.5 15ZM17.5 15H12.5C11.8237 14.9989 11.1654 15.2183 10.625 15.625V6.875C10.625 6.37772 10.8225 5.90081 11.1742 5.54917C11.5258 5.19754 12.0027 5 12.5 5H17.5V15Z"
          fill="url(#paint0_linear_3331_4632_library_icon)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3331_4632_library_icon"
            x1="1.25"
            y1="11.25"
            x2="18.75"
            y2="11.25"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C6A903" />
            <stop offset="1" stopColor="#DCC73D" />
          </linearGradient>
        </defs>
      </svg>
    ),
    iconFilled: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <rect
          x="1.25"
          y="3.75"
          width="17.5"
          height="12.5"
          rx="1.25"
          fill="url(#paint0_linear_3331_4632_filled_bg)"
        />
        <path
          d="M17.5 3.75H12.5C12.0149 3.75 11.5364 3.86295 11.1025 4.07991C10.6685 4.29688 10.2911 4.61189 10 5C9.70892 4.61189 9.33147 4.29688 8.89754 4.07991C8.46362 3.86295 7.98514 3.75 7.5 3.75H2.5C2.16848 3.75 1.85054 3.8817 1.61612 4.11612C1.3817 4.35054 1.25 4.66848 1.25 5V15C1.25 15.3315 1.3817 15.6495 1.61612 15.8839C1.85054 16.1183 2.16848 16.25 2.5 16.25H7.5C7.99728 16.25 8.47419 16.4475 8.82583 16.7992C9.17746 17.1508 9.375 17.6277 9.375 18.125C9.375 18.2908 9.44085 18.4497 9.55806 18.5669C9.67527 18.6842 9.83424 18.75 10 18.75C10.1658 18.75 10.3247 18.6842 10.4419 18.5669C10.5592 18.4497 10.625 18.2908 10.625 18.125C10.625 17.6277 10.8225 17.1508 11.1742 16.7992C11.5258 16.4475 12.0027 16.25 12.5 16.25H17.5C17.8315 16.25 18.1495 16.1183 18.3839 15.8839C18.6183 15.6495 18.75 15.3315 18.75 15V5C18.75 4.66848 18.6183 4.35054 18.3839 4.11612C18.1495 3.8817 17.8315 3.75 17.5 3.75ZM7.5 15H2.5V5H7.5C7.99728 5 8.47419 5.19754 8.82583 5.54917C9.17746 5.90081 9.375 6.37772 9.375 6.875V15.625C8.83458 15.2183 8.17633 14.9989 7.5 15ZM17.5 15H12.5C11.8237 14.9989 11.1654 15.2183 10.625 15.625V6.875C10.625 6.37772 10.8225 5.90081 11.1742 5.54917C11.5258 5.19754 12.0027 5 12.5 5H17.5V15Z"
          fill="url(#paint0_linear_3331_4632)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3331_4632_filled_bg"
            x1="1.25"
            y1="10"
            x2="18.75"
            y2="10"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C6A903" stopOpacity="0.2" />
            <stop offset="1" stopColor="#DCC73D" stopOpacity="0.2" />
          </linearGradient>
          <linearGradient
            id="paint0_linear_3331_4632"
            x1="1.25"
            y1="11.25"
            x2="18.75"
            y2="11.25"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C6A903" />
            <stop offset="1" stopColor="#DCC73D" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
};

interface NodeType {
  colors: {
    background: string;
    color: string;
    icon: React.ReactNode;
    iconFilled: React.ReactNode;
  };
  nodeIcon: React.ReactNode;
}

const nodeColorBasedOnType: { [key: string]: NodeType } = {
  commandTextNode: {
    colors: colors.text,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 14 10"
        fill="none"
      >
        <path
          d="M7 3H13.5C13.6326 3 13.7598 3.05268 13.8536 3.14645C13.9473 3.24021 14 3.36739 14 3.5C14 3.63261 13.9473 3.75979 13.8536 3.85355C13.7598 3.94732 13.6326 4 13.5 4H7C6.86739 4 6.74021 3.94732 6.64645 3.85355C6.55268 3.75979 6.5 3.63261 6.5 3.5C6.5 3.36739 6.55268 3.24021 6.64645 3.14645C6.74021 3.05268 6.86739 3 7 3ZM13.5 5H7C6.86739 5 6.74021 5.05268 6.64645 5.14645C6.55268 5.24021 6.5 5.36739 6.5 5.5C6.5 5.63261 6.55268 5.75979 6.64645 5.85355C6.74021 5.94732 6.86739 6 7 6H13.5C13.6326 6 13.7598 5.94732 13.8536 5.85355C13.9473 5.75979 14 5.63261 14 5.5C14 5.36739 13.9473 5.24021 13.8536 5.14645C13.7598 5.05268 13.6326 5 13.5 5ZM13.5 7H4C3.86739 7 3.74021 7.05268 3.64645 7.14645C3.55268 7.24021 3.5 7.36739 3.5 7.5C3.5 7.63261 3.55268 7.75979 3.64645 7.85355C3.74021 7.94732 3.86739 8 4 8H13.5C13.6326 8 13.7598 7.94732 13.8536 7.85355C13.9473 7.75979 14 7.63261 14 7.5C14 7.36739 13.9473 7.24021 13.8536 7.14645C13.7598 7.05268 13.6326 7 13.5 7ZM13.5 9H4C3.86739 9 3.74021 9.05268 3.64645 9.14645C3.55268 9.24021 3.5 9.36739 3.5 9.5C3.5 9.63261 3.55268 9.75979 3.64645 9.85355C3.74021 9.94732 3.86739 10 4 10H13.5C13.6326 10 13.7598 9.94732 13.8536 9.85355C13.9473 9.75979 14 9.63261 14 9.5C14 9.36739 13.9473 9.24021 13.8536 9.14645C13.7598 9.05268 13.6326 9 13.5 9ZM5 6C5.13261 6 5.25979 5.94732 5.35355 5.85355C5.44732 5.75979 5.5 5.63261 5.5 5.5C5.5 5.36739 5.44732 5.24021 5.35355 5.14645C5.25979 5.05268 5.13261 5 5 5H4.5V1H6.5V1.5C6.5 1.63261 6.55268 1.75979 6.64645 1.85355C6.74021 1.94732 6.86739 2 7 2C7.13261 2 7.25979 1.94732 7.35355 1.85355C7.44732 1.75979 7.5 1.63261 7.5 1.5V0.5C7.5 0.367392 7.44732 0.240215 7.35355 0.146447C7.25979 0.0526785 7.13261 0 7 0H1C0.867392 0 0.740215 0.0526785 0.646447 0.146447C0.552678 0.240215 0.5 0.367392 0.5 0.5V1.5C0.5 1.63261 0.552678 1.75979 0.646447 1.85355C0.740215 1.94732 0.867392 2 1 2C1.13261 2 1.25979 1.94732 1.35355 1.85355C1.44732 1.75979 1.5 1.63261 1.5 1.5V1H3.5V5H3C2.86739 5 2.74021 5.05268 2.64645 5.14645C2.55268 5.24021 2.5 5.36739 2.5 5.5C2.5 5.63261 2.55268 5.75979 2.64645 5.85355C2.74021 5.94732 2.86739 6 3 6H5Z"
          fill="url(#paint0_linear_4630_19300)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4630_19300"
            x1="6"
            y1="16"
            x2="26"
            y2="16"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1436FF" />
            <stop offset="1" stopColor="#396AFC" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  libraryNode: {
    colors: colors.library,
    nodeIcon: <BookOpen size={20} weight="regular" color="#C6A903" />,
  },
  outputController: {
    colors: colors.text,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 12 14"
        fill="none"
      >
        <path
          d="M11.1732 1.45264L3.0326 0.0151372C2.77145 -0.0308186 2.50273 0.0288276 2.28555 0.180959C2.06837 0.333091 1.92051 0.565251 1.87447 0.826387L0.0150955 11.3889C-0.00764638 11.5183 -0.0046671 11.6509 0.0238631 11.7791C0.0523934 11.9074 0.105915 12.0288 0.18137 12.1363C0.256825 12.2439 0.352735 12.3355 0.463617 12.406C0.5745 12.4764 0.698182 12.5244 0.827596 12.547L8.96822 13.9845C9.09766 14.0073 9.23034 14.0044 9.35866 13.9759C9.48698 13.9475 9.60842 13.894 9.71604 13.8185C9.82366 13.743 9.91535 13.6471 9.98586 13.5362C10.0564 13.4252 10.1043 13.3015 10.127 13.172L11.9863 2.60951C12.0319 2.34828 11.9718 2.07965 11.8193 1.8627C11.6669 1.64575 11.4344 1.49825 11.1732 1.45264ZM9.14072 12.9995L0.999471 11.562L2.85885 0.999512L10.9995 2.43701L9.14072 12.9995ZM3.58322 2.65076C3.60638 2.52024 3.68042 2.40427 3.78907 2.32832C3.89771 2.25238 4.03206 2.22268 4.1626 2.24576L9.3501 3.16139C9.47338 3.18298 9.58409 3.25004 9.66033 3.34929C9.73658 3.44855 9.77283 3.5728 9.76192 3.69749C9.751 3.82217 9.69372 3.93823 9.60139 4.02274C9.50905 4.10724 9.38838 4.15404 9.26322 4.15389C9.2339 4.15385 9.20463 4.15134 9.17572 4.14639L3.98822 3.23014C3.8577 3.20698 3.74172 3.13294 3.66578 3.02429C3.58983 2.91565 3.56014 2.78129 3.58322 2.65076ZM3.23697 4.62076C3.24837 4.55608 3.27239 4.49428 3.30768 4.43888C3.34297 4.38349 3.38882 4.33559 3.44263 4.29792C3.49643 4.26025 3.55713 4.23356 3.62125 4.21935C3.68537 4.20515 3.75167 4.20371 3.81635 4.21514L9.00385 5.13139C9.128 5.15215 9.23975 5.21898 9.31679 5.31853C9.39383 5.41808 9.43048 5.54303 9.41944 5.66842C9.40839 5.79381 9.35045 5.91042 9.25719 5.99497C9.16393 6.07952 9.04222 6.12578 8.91635 6.12451C8.88678 6.12457 8.85728 6.12185 8.82822 6.11639L3.64072 5.20076C3.5103 5.17732 3.39453 5.10306 3.31882 4.99431C3.24312 4.88556 3.21368 4.75121 3.23697 4.62076ZM2.8901 6.59014C2.91369 6.45996 2.98791 6.34445 3.09651 6.26889C3.2051 6.19333 3.33921 6.16389 3.46947 6.18701L6.06197 6.64264C6.1852 6.66423 6.29587 6.73123 6.37211 6.83042C6.44836 6.92961 6.48465 7.05378 6.47382 7.17842C6.46298 7.30307 6.40582 7.41912 6.31361 7.50367C6.22139 7.58822 6.10083 7.63513 5.97572 7.63514C5.94639 7.63512 5.91712 7.63261 5.88822 7.62764L3.29447 7.16951C3.16407 7.14621 3.04824 7.0721 2.97243 6.96348C2.89661 6.85485 2.867 6.72058 2.8901 6.59014Z"
          fill="url(#paint0_linear_4630_19300)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4630_19300"
            x1="6"
            y1="16"
            x2="26"
            y2="16"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1436FF" />
            <stop offset="1" stopColor="#396AFC" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  reportBuilder: {
    colors: colors.text,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 12 14"
        fill="none"
      >
        <path
          d="M 10.78 2 H 1.1 A 0.88 0.88 90 0 0 0.22 2.88 V 11.68 a 0.44 0.44 90 0 0 0.6369 0.3933 L 2.42 11.2917 l 1.5631 0.7816 a 0.44 0.44 90 0 0 0.3938 0 L 5.94 11.2917 l 1.5631 0.7816 a 0.44 0.44 90 0 0 0.3938 0 L 9.46 11.2917 l 1.5631 0.7816 A 0.44 0.44 90 0 0 11.66 11.68 V 2.88 A 0.88 0.88 90 0 0 10.78 2 Z m 0 8.9683 l -1.1231 -0.5621 a 0.44 0.44 90 0 0 -0.3938 0 L 7.7 11.1883 l -1.5631 -0.7821 a 0.44 0.44 90 0 0 -0.3938 0 L 4.18 11.1883 L 2.6169 10.4062 a 0.44 0.44 90 0 0 -0.3938 0 L 1.1 10.9683 V 2.88 H 10.78 Z M 6.38 5.96 a 0.44 0.44 90 0 1 0.44 -0.44 h 2.64 a 0.44 0.44 90 0 1 0 0.88 H 6.82 A 0.44 0.44 90 0 1 6.38 5.96 Z m 0 1.76 a 0.44 0.44 90 0 1 0.44 -0.44 h 2.64 a 0.44 0.44 90 0 1 0 0.88 H 6.82 A 0.44 0.44 90 0 1 6.38 7.72 Z M 2.42 9.04 h 2.64 a 0.44 0.44 90 0 0 0.44 -0.44 V 5.08 a 0.44 0.44 90 0 0 -0.44 -0.44 H 2.42 a 0.44 0.44 90 0 0 -0.44 0.44 v 3.52 A 0.44 0.44 90 0 0 2.42 9.04 Z m 0.44 -3.52 h 1.76 v 2.64 H 2.86 Z"
          fill="url(#paint0_linear_4630_19300)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4630_19300"
            x1="6"
            y1="16"
            x2="26"
            y2="16"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1436FF" />
            <stop offset="1" stopColor="#396AFC" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  fluxObject: {
    colors: colors.data,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M11 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V11C0 11.2652 0.105357 11.5196 0.292893 11.7071C0.48043 11.8946 0.734784 12 1 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11V1C12 0.734784 11.8946 0.48043 11.7071 0.292893C11.5196 0.105357 11.2652 0 11 0ZM11 1V7.5H9.20625C9.07499 7.49966 8.94496 7.5254 8.82372 7.57572C8.70248 7.62604 8.59245 7.69994 8.5 7.79313L7.29313 9H4.70687L3.5 7.79313C3.40748 7.69986 3.29734 7.62592 3.17599 7.5756C3.05464 7.52528 2.9245 7.49958 2.79313 7.5H1V1H11ZM11 11H1V8.5H2.79313L4 9.70687C4.09252 9.80014 4.20266 9.87408 4.32401 9.9244C4.44536 9.97472 4.5755 10.0004 4.70687 10H7.29313C7.4245 10.0004 7.55464 9.97472 7.67599 9.9244C7.79734 9.87408 7.90748 9.80014 8 9.70687L9.20687 8.5H11V11ZM3.64625 5.85375C3.55243 5.75993 3.49972 5.63268 3.49972 5.5C3.49972 5.36732 3.55243 5.24007 3.64625 5.14625C3.74007 5.05243 3.86732 4.99972 4 4.99972C4.13268 4.99972 4.25993 5.05243 4.35375 5.14625L5.5 6.29313V2.5C5.5 2.36739 5.55268 2.24021 5.64645 2.14645C5.74021 2.05268 5.86739 2 6 2C6.13261 2 6.25979 2.05268 6.35355 2.14645C6.44732 2.24021 6.5 2.36739 6.5 2.5V6.29313L7.64625 5.14625C7.6927 5.09979 7.74786 5.06294 7.80855 5.0378C7.86925 5.01266 7.9343 4.99972 8 4.99972C8.0657 4.99972 8.13075 5.01266 8.19145 5.0378C8.25214 5.06294 8.3073 5.09979 8.35375 5.14625C8.40021 5.1927 8.43706 5.24786 8.4622 5.30855C8.48734 5.36925 8.50028 5.4343 8.50028 5.5C8.50028 5.5657 8.48734 5.63075 8.4622 5.69145C8.43706 5.75214 8.40021 5.8073 8.35375 5.85375L6.35375 7.85375C6.30731 7.90024 6.25217 7.93712 6.19147 7.96228C6.13077 7.98744 6.06571 8.00039 6 8.00039C5.93429 8.00039 5.86923 7.98744 5.80853 7.96228C5.74783 7.93712 5.69269 7.90024 5.64625 7.85375L3.64625 5.85375Z"
          fill="url(#paint0_linear_1056_25983)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_25983"
            x1="8"
            y1="23.4286"
            x2="27.0053"
            y2="10.3407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF512F" />
            <stop offset="1" stopColor="#F09819" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  varInputNode: {
    colors: colors.external,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8.00028 8.5V12.5C8.00036 12.5989 7.97107 12.6957 7.91614 12.778C7.8612 12.8603 7.78308 12.9244 7.69167 12.9623C7.60026 13.0002 7.49967 13.0101 7.40262 12.9908C7.30558 12.9714 7.21646 12.9238 7.14653 12.8538L5.50028 11.2069L2.85403 13.8538C2.80757 13.9002 2.75242 13.9371 2.69173 13.9622C2.63103 13.9873 2.56598 14.0003 2.50028 14.0003C2.43458 14.0003 2.36953 13.9873 2.30883 13.9622C2.24813 13.9371 2.19298 13.9002 2.14653 13.8538C2.10007 13.8073 2.06322 13.7521 2.03808 13.6914C2.01294 13.6308 2 13.5657 2 13.5C2 13.4343 2.01294 13.3692 2.03808 13.3086C2.06322 13.2479 2.10007 13.1927 2.14653 13.1462L4.7934 10.5L3.14653 8.85375C3.07652 8.78382 3.02884 8.6947 3.00951 8.59765C2.99019 8.50061 3.00009 8.40002 3.03797 8.30861C3.07584 8.21719 3.13999 8.13908 3.22229 8.08414C3.30458 8.0292 3.40133 7.99992 3.50028 8H7.50028C7.63289 8 7.76006 8.05268 7.85383 8.14645C7.9476 8.24021 8.00028 8.36739 8.00028 8.5ZM13.0003 2H5.00028C4.73506 2 4.48071 2.10536 4.29317 2.29289C4.10563 2.48043 4.00028 2.73478 4.00028 3V6C4.00028 6.13261 4.05296 6.25979 4.14672 6.35355C4.24049 6.44732 4.36767 6.5 4.50028 6.5C4.63289 6.5 4.76006 6.44732 4.85383 6.35355C4.9476 6.25979 5.00028 6.13261 5.00028 6V3H13.0003V11H10.0003C9.86767 11 9.74049 11.0527 9.64672 11.1464C9.55296 11.2402 9.50028 11.3674 9.50028 11.5C9.50028 11.6326 9.55296 11.7598 9.64672 11.8536C9.74049 11.9473 9.86767 12 10.0003 12H13.0003C13.2655 12 13.5198 11.8946 13.7074 11.7071C13.8949 11.5196 14.0003 11.2652 14.0003 11V3C14.0003 2.73478 13.8949 2.48043 13.7074 2.29289C13.5198 2.10536 13.2655 2 13.0003 2Z"
          fill="url(#paint0_linear_537_24169)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_537_24169"
            x1="3.33336"
            y1="23.4668"
            x2="23.8892"
            y2="4.37212"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0572917" stopColor="#FD746C" />
            <stop offset="0.494792" stopColor="#FE846A" />
            <stop offset="0.932292" stopColor="#FF9068" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  nodesAdd: {
    colors: colors.external,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8.00028 8.5V12.5C8.00036 12.5989 7.97107 12.6957 7.91614 12.778C7.8612 12.8603 7.78308 12.9244 7.69167 12.9623C7.60026 13.0002 7.49967 13.0101 7.40262 12.9908C7.30558 12.9714 7.21646 12.9238 7.14653 12.8538L5.50028 11.2069L2.85403 13.8538C2.80757 13.9002 2.75242 13.9371 2.69173 13.9622C2.63103 13.9873 2.56598 14.0003 2.50028 14.0003C2.43458 14.0003 2.36953 13.9873 2.30883 13.9622C2.24813 13.9371 2.19298 13.9002 2.14653 13.8538C2.10007 13.8073 2.06322 13.7521 2.03808 13.6914C2.01294 13.6308 2 13.5657 2 13.5C2 13.4343 2.01294 13.3692 2.03808 13.3086C2.06322 13.2479 2.10007 13.1927 2.14653 13.1462L4.7934 10.5L3.14653 8.85375C3.07652 8.78382 3.02884 8.6947 3.00951 8.59765C2.99019 8.50061 3.00009 8.40002 3.03797 8.30861C3.07584 8.21719 3.13999 8.13908 3.22229 8.08414C3.30458 8.0292 3.40133 7.99992 3.50028 8H7.50028C7.63289 8 7.76006 8.05268 7.85383 8.14645C7.9476 8.24021 8.00028 8.36739 8.00028 8.5ZM13.0003 2H5.00028C4.73506 2 4.48071 2.10536 4.29317 2.29289C4.10563 2.48043 4.00028 2.73478 4.00028 3V6C4.00028 6.13261 4.05296 6.25979 4.14672 6.35355C4.24049 6.44732 4.36767 6.5 4.50028 6.5C4.63289 6.5 4.76006 6.44732 4.85383 6.35355C4.9476 6.25979 5.00028 6.13261 5.00028 6V3H13.0003V11H10.0003C9.86767 11 9.74049 11.0527 9.64672 11.1464C9.55296 11.2402 9.50028 11.3674 9.50028 11.5C9.50028 11.6326 9.55296 11.7598 9.64672 11.8536C9.74049 11.9473 9.86767 12 10.0003 12H13.0003C13.2655 12 13.5198 11.8946 13.7074 11.7071C13.8949 11.5196 14.0003 11.2652 14.0003 11V3C14.0003 2.73478 13.8949 2.48043 13.7074 2.29289C13.5198 2.10536 13.2655 2 13.0003 2Z"
          fill="url(#paint0_linear_537_24169)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_537_24169"
            x1="3.33336"
            y1="23.4668"
            x2="23.8892"
            y2="4.37212"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0572917" stopColor="#FD746C" />
            <stop offset="0.494792" stopColor="#FE846A" />
            <stop offset="0.932292" stopColor="#FF9068" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  edgesAdd: {
    colors: colors.external,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8.00028 8.5V12.5C8.00036 12.5989 7.97107 12.6957 7.91614 12.778C7.8612 12.8603 7.78308 12.9244 7.69167 12.9623C7.60026 13.0002 7.49967 13.0101 7.40262 12.9908C7.30558 12.9714 7.21646 12.9238 7.14653 12.8538L5.50028 11.2069L2.85403 13.8538C2.80757 13.9002 2.75242 13.9371 2.69173 13.9622C2.63103 13.9873 2.56598 14.0003 2.50028 14.0003C2.43458 14.0003 2.36953 13.9873 2.30883 13.9622C2.24813 13.9371 2.19298 13.9002 2.14653 13.8538C2.10007 13.8073 2.06322 13.7521 2.03808 13.6914C2.01294 13.6308 2 13.5657 2 13.5C2 13.4343 2.01294 13.3692 2.03808 13.3086C2.06322 13.2479 2.10007 13.1927 2.14653 13.1462L4.7934 10.5L3.14653 8.85375C3.07652 8.78382 3.02884 8.6947 3.00951 8.59765C2.99019 8.50061 3.00009 8.40002 3.03797 8.30861C3.07584 8.21719 3.13999 8.13908 3.22229 8.08414C3.30458 8.0292 3.40133 7.99992 3.50028 8H7.50028C7.63289 8 7.76006 8.05268 7.85383 8.14645C7.9476 8.24021 8.00028 8.36739 8.00028 8.5ZM13.0003 2H5.00028C4.73506 2 4.48071 2.10536 4.29317 2.29289C4.10563 2.48043 4.00028 2.73478 4.00028 3V6C4.00028 6.13261 4.05296 6.25979 4.14672 6.35355C4.24049 6.44732 4.36767 6.5 4.50028 6.5C4.63289 6.5 4.76006 6.44732 4.85383 6.35355C4.9476 6.25979 5.00028 6.13261 5.00028 6V3H13.0003V11H10.0003C9.86767 11 9.74049 11.0527 9.64672 11.1464C9.55296 11.2402 9.50028 11.3674 9.50028 11.5C9.50028 11.6326 9.55296 11.7598 9.64672 11.8536C9.74049 11.9473 9.86767 12 10.0003 12H13.0003C13.2655 12 13.5198 11.8946 13.7074 11.7071C13.8949 11.5196 14.0003 11.2652 14.0003 11V3C14.0003 2.73478 13.8949 2.48043 13.7074 2.29289C13.5198 2.10536 13.2655 2 13.0003 2Z"
          fill="url(#paint0_linear_537_24169)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_537_24169"
            x1="3.33336"
            y1="23.4668"
            x2="23.8892"
            y2="4.37212"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0572917" stopColor="#FD746C" />
            <stop offset="0.494792" stopColor="#FE846A" />
            <stop offset="0.932292" stopColor="#FF9068" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  outputObjectNode: {
    colors: colors.external,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M12 8.5V13C12 13.2652 11.8946 13.5196 11.7071 13.7071C11.5196 13.8946 11.2652 14 11 14H3C2.73478 14 2.48043 13.8946 2.29289 13.7071C2.10536 13.5196 2 13.2652 2 13V5C2 4.73478 2.10536 4.48043 2.29289 4.29289C2.48043 4.10536 2.73478 4 3 4H7.5C7.63261 4 7.75979 4.05268 7.85355 4.14645C7.94732 4.24022 8 4.36739 8 4.5C8 4.63261 7.94732 4.75979 7.85355 4.85355C7.75979 4.94732 7.63261 5 7.5 5H3V13H11V8.5C11 8.36739 11.0527 8.24021 11.1464 8.14645C11.2402 8.05268 11.3674 8 11.5 8C11.6326 8 11.7598 8.05268 11.8536 8.14645C11.9473 8.24021 12 8.36739 12 8.5ZM14 2.5C14 2.36739 13.9473 2.24022 13.8536 2.14645C13.7598 2.05268 13.6326 2 13.5 2H9.5C9.40105 1.99992 9.30431 2.0292 9.22201 2.08414C9.13971 2.13908 9.07557 2.21719 9.03769 2.30861C8.99981 2.40002 8.98991 2.50061 9.00924 2.59765C9.02856 2.6947 9.07624 2.78382 9.14625 2.85375L10.7931 4.5L8.14625 7.14625C8.05243 7.24007 7.99972 7.36732 7.99972 7.5C7.99972 7.63268 8.05243 7.75993 8.14625 7.85375C8.24007 7.94757 8.36732 8.00028 8.5 8.00028C8.63268 8.00028 8.75993 7.94757 8.85375 7.85375L11.5 5.20688L13.1462 6.85375C13.2162 6.92376 13.3053 6.97144 13.4023 6.99076C13.4994 7.01009 13.6 7.00019 13.6914 6.96231C13.7828 6.92444 13.8609 6.86029 13.9159 6.77799C13.9708 6.69569 14.0001 6.59895 14 6.5V2.5Z"
          fill="url(#paint0_linear_537_24169)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_537_24169"
            x1="3.33336"
            y1="23.4668"
            x2="23.8892"
            y2="4.37212"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0572917" stopColor="#FD746C" />
            <stop offset="0.494792" stopColor="#FE846A" />
            <stop offset="0.932292" stopColor="#FF9068" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  conditionNode: {
    colors: colors.functions,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M13.3541 10.8538L11.3541 12.8538C11.3077 12.9002 11.2526 12.9371 11.1919 12.9623C11.1312 12.9874 11.0661 13.0004 11.0004 13.0004C10.9347 13.0004 10.8696 12.9874 10.8089 12.9623C10.7482 12.9371 10.6931 12.9002 10.6466 12.8538L8.64664 10.8538C8.57664 10.7838 8.52895 10.6947 8.50963 10.5977C8.4903 10.5006 8.50021 10.4 8.53808 10.3086C8.57596 10.2172 8.64011 10.1391 8.7224 10.0841C8.8047 10.0292 8.90145 9.99992 9.00039 10H10.5004V7.70687L7.00039 4.20687L3.50039 7.70687V10H5.00039C5.09934 9.99992 5.19609 10.0292 5.27838 10.0841C5.36068 10.1391 5.42483 10.2172 5.46271 10.3086C5.50058 10.4 5.51048 10.5006 5.49116 10.5977C5.47183 10.6947 5.42415 10.7838 5.35414 10.8538L3.35414 12.8538C3.30771 12.9002 3.25256 12.9371 3.19186 12.9623C3.13116 12.9874 3.0661 13.0004 3.00039 13.0004C2.93469 13.0004 2.86962 12.9874 2.80892 12.9623C2.74822 12.9371 2.69308 12.9002 2.64664 12.8538L0.646644 10.8538C0.576638 10.7838 0.528954 10.6947 0.509629 10.5977C0.490304 10.5006 0.500206 10.4 0.538082 10.3086C0.575959 10.2172 0.640106 10.1391 0.722403 10.0841C0.8047 10.0292 0.901446 9.99992 1.00039 10H2.50039V7.5C2.50034 7.43432 2.51323 7.36927 2.53833 7.30857C2.56342 7.24788 2.60023 7.19272 2.64664 7.14625L6.50039 3.29313V0.5C6.50039 0.367392 6.55307 0.240215 6.64684 0.146447C6.74061 0.0526784 6.86779 0 7.00039 0C7.133 0 7.26018 0.0526784 7.35395 0.146447C7.44772 0.240215 7.50039 0.367392 7.50039 0.5V3.29313L11.3541 7.14625C11.4006 7.19272 11.4374 7.24788 11.4625 7.30857C11.4876 7.36927 11.5004 7.43432 11.5004 7.5V10H13.0004C13.0993 9.99992 13.1961 10.0292 13.2784 10.0841C13.3607 10.1391 13.4248 10.2172 13.4627 10.3086C13.5006 10.4 13.5105 10.5006 13.4912 10.5977C13.4718 10.6947 13.4241 10.7838 13.3541 10.8538Z"
          fill="url(#paint0_linear_696_31608)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_696_31608"
            x1="5.62963"
            y1="24.5556"
            x2="27.6667"
            y2="9.77778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2BCCE1" />
            <stop offset="1" stopColor="#0ED2F7" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  textBox: {
    colors: colors.text,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M13.5 2.5H2.5C2.23478 2.5 1.98043 2.60536 1.79289 2.79289C1.60536 2.98043 1.5 3.23478 1.5 3.5V12.5C1.5 12.7652 1.60536 13.0196 1.79289 13.2071C1.98043 13.3946 2.23478 13.5 2.5 13.5H13.5C13.7652 13.5 14.0196 13.3946 14.2071 13.2071C14.3946 13.0196 14.5 12.7652 14.5 12.5V3.5C14.5 3.23478 14.3946 2.98043 14.2071 2.79289C14.0196 2.60536 13.7652 2.5 13.5 2.5ZM13.5 12.5H2.5V3.5H13.5V12.5ZM11.5 6C11.5 6.13261 11.4473 6.25979 11.3536 6.35355C11.2598 6.44732 11.1326 6.5 11 6.5H5C4.86739 6.5 4.74021 6.44732 4.64645 6.35355C4.55268 6.25979 4.5 6.13261 4.5 6C4.5 5.86739 4.55268 5.74021 4.64645 5.64645C4.74021 5.55268 4.86739 5.5 5 5.5H11C11.1326 5.5 11.2598 5.55268 11.3536 5.64645C11.4473 5.74021 11.5 5.86739 11.5 6ZM11.5 8C11.5 8.13261 11.4473 8.25979 11.3536 8.35355C11.2598 8.44732 11.1326 8.5 11 8.5H5C4.86739 8.5 4.74021 8.44732 4.64645 8.35355C4.55268 8.25979 4.5 8.13261 4.5 8C4.5 7.86739 4.55268 7.74021 4.64645 7.64645C4.74021 7.55268 4.86739 7.5 5 7.5H11C11.1326 7.5 11.2598 7.55268 11.3536 7.64645C11.4473 7.74021 11.5 7.86739 11.5 8ZM11.5 10C11.5 10.1326 11.4473 10.2598 11.3536 10.3536C11.2598 10.4473 11.1326 10.5 11 10.5H5C4.86739 10.5 4.74021 10.4473 4.64645 10.3536C4.55268 10.2598 4.5 10.1326 4.5 10C4.5 9.86739 4.55268 9.74021 4.64645 9.64645C4.74021 9.55268 4.86739 9.5 5 9.5H11C11.1326 9.5 11.2598 9.55268 11.3536 9.64645C11.4473 9.74021 11.5 9.86739 11.5 10Z"
          fill="url(#paint0_linear_4630_19300)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4630_19300"
            x1="6"
            y1="16"
            x2="26"
            y2="16"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1436FF" />
            <stop offset="1" stopColor="#396AFC" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  richTextBox: {
    colors: colors.text,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M12.5 3.5C12.5 3.63261 12.4473 3.75979 12.3536 3.85355C12.2598 3.94732 12.1326 4 12 4H9.86063L7.19375 12H9C9.13261 12 9.25979 12.0527 9.35355 12.1464C9.44732 12.2402 9.5 12.3674 9.5 12.5C9.5 12.6326 9.44732 12.7598 9.35355 12.8536C9.25979 12.9473 9.13261 13 9 13H4C3.86739 13 3.74021 12.9473 3.64645 12.8536C3.55268 12.7598 3.5 12.6326 3.5 12.5C3.5 12.3674 3.55268 12.2402 3.64645 12.1464C3.74021 12.0527 3.86739 12 4 12H6.13938L8.80625 4H7C6.86739 4 6.74021 3.94732 6.64645 3.85355C6.55268 3.75979 6.5 3.63261 6.5 3.5C6.5 3.36739 6.55268 3.24021 6.64645 3.14645C6.74021 3.05268 6.86739 3 7 3H12C12.1326 3 12.2598 3.05268 12.3536 3.14645C12.4473 3.24021 12.5 3.36739 12.5 3.5Z"
          fill="url(#paint0_linear_4630_19300)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4630_19300"
            x1="6"
            y1="16"
            x2="26"
            y2="16"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1436FF" />
            <stop offset="1" stopColor="#396AFC" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  voiceBoxNode: {
    colors: colors.audio,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M9.21937 0.550524C9.13529 0.509552 9.0414 0.492986 8.94838 0.502709C8.85535 0.512431 8.76692 0.548052 8.69312 0.605524L4.32812 3.9999H1.5C1.23478 3.9999 0.98043 4.10526 0.792893 4.29279C0.605357 4.48033 0.5 4.73468 0.5 4.9999V8.9999C0.5 9.26512 0.605357 9.51947 0.792893 9.70701C0.98043 9.89454 1.23478 9.9999 1.5 9.9999H4.32812L8.69312 13.3943C8.76699 13.4517 8.85548 13.4872 8.94855 13.4969C9.04161 13.5065 9.13551 13.4898 9.21956 13.4487C9.30362 13.4077 9.37446 13.3438 9.42404 13.2645C9.47361 13.1851 9.49993 13.0935 9.5 12.9999V0.999899C9.50001 0.906229 9.47371 0.814439 9.4241 0.734988C9.37448 0.655538 9.30355 0.591622 9.21937 0.550524ZM8.5 11.9774L4.80688 9.10552C4.71931 9.03692 4.61124 8.99972 4.5 8.9999H1.5V4.9999H4.5C4.61124 5.00008 4.71931 4.96288 4.80688 4.89427L8.5 2.0224V11.9774ZM12 5.4999V8.4999C12 8.63251 11.9473 8.75968 11.8536 8.85345C11.7598 8.94722 11.6326 8.9999 11.5 8.9999C11.3674 8.9999 11.2402 8.94722 11.1464 8.85345C11.0527 8.75968 11 8.63251 11 8.4999V5.4999C11 5.36729 11.0527 5.24011 11.1464 5.14635C11.2402 5.05258 11.3674 4.9999 11.5 4.9999C11.6326 4.9999 11.7598 5.05258 11.8536 5.14635C11.9473 5.24011 12 5.36729 12 5.4999ZM14 4.4999V9.4999C14 9.63251 13.9473 9.75968 13.8536 9.85345C13.7598 9.94722 13.6326 9.9999 13.5 9.9999C13.3674 9.9999 13.2402 9.94722 13.1464 9.85345C13.0527 9.75968 13 9.63251 13 9.4999V4.4999C13 4.36729 13.0527 4.24011 13.1464 4.14635C13.2402 4.05258 13.3674 3.9999 13.5 3.9999C13.6326 3.9999 13.7598 4.05258 13.8536 4.14635C13.9473 4.24011 14 4.36729 14 4.4999Z"
          fill="url(#paint0_linear_1056_24276)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_24276"
            x1="6.725"
            y1="26.7244"
            x2="28.6558"
            y2="15.3368"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#73E49A" />
            <stop offset="0.989583" stopColor="#3FC36D" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  commandContentNode: {
    colors: colors.data,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M14.5 3.5H1.5C1.23478 3.5 0.98043 3.60536 0.792893 3.79289C0.605357 3.98043 0.5 4.23478 0.5 4.5V12.5C0.5 12.6326 0.552678 12.7598 0.646447 12.8536C0.740215 12.9473 0.867392 13 1 13C1.13261 13 1.25979 12.9473 1.35355 12.8536C1.44732 12.7598 1.5 12.6326 1.5 12.5V11.5H2.5V12.5C2.5 12.6326 2.55268 12.7598 2.64645 12.8536C2.74021 12.9473 2.86739 13 3 13C3.13261 13 3.25979 12.9473 3.35355 12.8536C3.44732 12.7598 3.5 12.6326 3.5 12.5V11.5H4.5V12.5C4.5 12.6326 4.55268 12.7598 4.64645 12.8536C4.74021 12.9473 4.86739 13 5 13C5.13261 13 5.25979 12.9473 5.35355 12.8536C5.44732 12.7598 5.5 12.6326 5.5 12.5V11.5H6.5V12.5C6.5 12.6326 6.55268 12.7598 6.64645 12.8536C6.74021 12.9473 6.86739 13 7 13C7.13261 13 7.25979 12.9473 7.35355 12.8536C7.44732 12.7598 7.5 12.6326 7.5 12.5V11.5H8.5V12.5C8.5 12.6326 8.55268 12.7598 8.64645 12.8536C8.74021 12.9473 8.86739 13 9 13C9.13261 13 9.25979 12.9473 9.35355 12.8536C9.44732 12.7598 9.5 12.6326 9.5 12.5V11.5H10.5V12.5C10.5 12.6326 10.5527 12.7598 10.6464 12.8536C10.7402 12.9473 10.8674 13 11 13C11.1326 13 11.2598 12.9473 11.3536 12.8536C11.4473 12.7598 11.5 12.6326 11.5 12.5V11.5H12.5V12.5C12.5 12.6326 12.5527 12.7598 12.6464 12.8536C12.7402 12.9473 12.8674 13 13 13C13.1326 13 13.2598 12.9473 13.3536 12.8536C13.4473 12.7598 13.5 12.6326 13.5 12.5V11.5H14.5V12.5C14.5 12.6326 14.5527 12.7598 14.6464 12.8536C14.7402 12.9473 14.8674 13 15 13C15.1326 13 15.2598 12.9473 15.3536 12.8536C15.4473 12.7598 15.5 12.6326 15.5 12.5V4.5C15.5 4.23478 15.3946 3.98043 15.2071 3.79289C15.0196 3.60536 14.7652 3.5 14.5 3.5ZM1.5 4.5H14.5V10.5H1.5V4.5ZM7 9.5C7.13261 9.5 7.25979 9.44732 7.35355 9.35355C7.44732 9.25979 7.5 9.13261 7.5 9V6C7.5 5.86739 7.44732 5.74021 7.35355 5.64645C7.25979 5.55268 7.13261 5.5 7 5.5H3C2.86739 5.5 2.74021 5.55268 2.64645 5.64645C2.55268 5.74021 2.5 5.86739 2.5 6V9C2.5 9.13261 2.55268 9.25979 2.64645 9.35355C2.74021 9.44732 2.86739 9.5 3 9.5H7ZM3.5 6.5H6.5V8.5H3.5V6.5ZM9 9.5H13C13.1326 9.5 13.2598 9.44732 13.3536 9.35355C13.4473 9.25979 13.5 9.13261 13.5 9V6C13.5 5.86739 13.4473 5.74021 13.3536 5.64645C13.2598 5.55268 13.1326 5.5 13 5.5H9C8.86739 5.5 8.74021 5.55268 8.64645 5.64645C8.55268 5.74021 8.5 5.86739 8.5 6V9C8.5 9.13261 8.55268 9.25979 8.64645 9.35355C8.74021 9.44732 8.86739 9.5 9 9.5ZM9.5 6.5H12.5V8.5H9.5V6.5Z"
          fill="url(#paint0_linear_1056_25983)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_25983"
            x1="8"
            y1="23.4286"
            x2="27.0053"
            y2="10.3407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF512F" />
            <stop offset="1" stopColor="#F09819" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  nodesBox: {
    colors: colors.data,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M13.8538 5.64625L10.3538 2.14625C10.3073 2.09983 10.2521 2.06303 10.1914 2.03793C10.1307 2.01284 10.0657 1.99995 10 2H2.5C2.36739 2 2.24021 2.05268 2.14645 2.14645C2.05268 2.24022 2 2.36739 2 2.5V10C2.00006 10.1312 2.05168 10.2571 2.14375 10.3506L5.64375 13.8506C5.69026 13.8979 5.74571 13.9355 5.80687 13.9611C5.86803 13.9868 5.93368 14 6 14H13.5C13.6326 14 13.7598 13.9473 13.8536 13.8536C13.9473 13.7598 14 13.6326 14 13.5V6C14.0001 5.93432 13.9872 5.86927 13.9621 5.80858C13.937 5.74788 13.9002 5.69272 13.8538 5.64625ZM10.5 3.70688L12.2931 5.5H10.5V3.70688ZM5.5 12.2931L3.70688 10.5H5.5V12.2931ZM5.5 9.5H3V3.70688L5.5 6.20687V9.5ZM3.70688 3H9.5V5.5H6.20687L3.70688 3ZM9.5 6.5V9.5H6.5V6.5H9.5ZM6.5 13V10.5H9.79313L12.2931 13H6.5ZM13 12.2931L10.5 9.79313V6.5H13V12.2931Z"
          fill="url(#paint0_linear_1056_25983)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_25983"
            x1="8"
            y1="23.4286"
            x2="27.0053"
            y2="10.3407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF512F" />
            <stop offset="1" stopColor="#F09819" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  fluxBox: {
    colors: colors.external,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M15.3527 4.64653L13.3527 2.64653C13.2589 2.55271 13.1316 2.5 12.9989 2.5C12.8663 2.5 12.739 2.55271 12.6452 2.64653C12.5514 2.74035 12.4987 2.8676 12.4987 3.00028C12.4987 3.13296 12.5514 3.26021 12.6452 3.35403L13.7921 4.50028H11.9989C11.3864 4.52248 10.7842 4.66542 10.2271 4.9209C9.37582 5.31403 8.3002 6.15278 8.00582 7.9209C7.67332 9.91715 6.18707 10.3722 5.44332 10.4747C5.31218 9.86932 4.96101 9.33423 4.45785 8.97305C3.95469 8.61187 3.33537 8.45032 2.7199 8.51972C2.10443 8.58911 1.53663 8.8845 1.12653 9.34865C0.716423 9.8128 0.493216 10.4127 0.500157 11.032C0.507099 11.6513 0.743694 12.246 1.1641 12.7009C1.5845 13.1557 2.15878 13.4383 2.77565 13.4939C3.39252 13.5495 4.00807 13.3741 4.503 13.0017C4.99794 12.6294 5.33703 12.0865 5.45457 11.4784C5.90408 11.4272 6.34324 11.3081 6.75707 11.1253C7.60832 10.7503 8.68645 9.91278 8.99207 8.08215C9.41457 5.5484 11.8952 5.50028 11.9989 5.50028H13.7921L12.6452 6.64653C12.5514 6.74035 12.4987 6.8676 12.4987 7.00028C12.4987 7.13296 12.5514 7.26021 12.6452 7.35403C12.739 7.44785 12.8663 7.50056 12.9989 7.50056C13.1316 7.50056 13.2589 7.44785 13.3527 7.35403L15.3527 5.35403C15.3992 5.30759 15.4361 5.25245 15.4612 5.19175C15.4864 5.13105 15.4993 5.06599 15.4993 5.00028C15.4993 4.93457 15.4864 4.86951 15.4612 4.80881C15.4361 4.74811 15.3992 4.69296 15.3527 4.64653ZM2.99895 12.5003C2.70227 12.5003 2.41226 12.4123 2.16559 12.2475C1.91892 12.0827 1.72666 11.8484 1.61313 11.5743C1.4996 11.3002 1.46989 10.9986 1.52777 10.7076C1.58565 10.4167 1.72851 10.1494 1.93829 9.93962C2.14806 9.72984 2.41534 9.58698 2.70631 9.5291C2.99728 9.47122 3.29888 9.50093 3.57297 9.61446C3.84706 9.72799 4.08133 9.92025 4.24615 10.1669C4.41097 10.4136 4.49895 10.7036 4.49895 11.0003C4.49895 11.3981 4.34091 11.7796 4.05961 12.0609C3.7783 12.3422 3.39677 12.5003 2.99895 12.5003Z"
          fill="url(#paint0_linear_537_24169)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_537_24169"
            x1="3.33336"
            y1="23.4668"
            x2="23.8892"
            y2="4.37212"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0572917" stopColor="#FD746C" />
            <stop offset="0.494792" stopColor="#FE846A" />
            <stop offset="0.932292" stopColor="#FF9068" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  imageGenerator: {
    colors: colors.image,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M13 2H5C4.73478 2 4.48043 2.10536 4.29289 2.29289C4.10536 2.48043 4 2.73478 4 3V4H3C2.73478 4 2.48043 4.10536 2.29289 4.29289C2.10536 4.48043 2 4.73478 2 5V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H11C11.2652 14 11.5196 13.8946 11.7071 13.7071C11.8946 13.5196 12 13.2652 12 13V12H13C13.2652 12 13.5196 11.8946 13.7071 11.7071C13.8946 11.5196 14 11.2652 14 11V3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2ZM5 3H13V7.33625L11.9563 6.2925C11.7687 6.10511 11.5145 5.99984 11.2494 5.99984C10.9843 5.99984 10.73 6.10511 10.5425 6.2925L5.83563 11H5V3ZM11 13H3V5H4V11C4 11.2652 4.10536 11.5196 4.29289 11.7071C4.48043 11.8946 4.73478 12 5 12H11V13ZM13 11H7.25L11.25 7L13 8.75V11ZM7.5 7C7.79667 7 8.08668 6.91203 8.33335 6.7472C8.58003 6.58238 8.77229 6.34811 8.88582 6.07403C8.99935 5.79994 9.02906 5.49834 8.97118 5.20736C8.9133 4.91639 8.77044 4.64912 8.56066 4.43934C8.35088 4.22956 8.08361 4.0867 7.79264 4.02882C7.50166 3.97094 7.20006 4.00065 6.92597 4.11418C6.65189 4.22771 6.41762 4.41997 6.2528 4.66664C6.08797 4.91332 6 5.20333 6 5.5C6 5.89782 6.15804 6.27936 6.43934 6.56066C6.72064 6.84196 7.10218 7 7.5 7ZM7.5 5C7.59889 5 7.69556 5.02932 7.77779 5.08427C7.86001 5.13921 7.9241 5.2173 7.96194 5.30866C7.99978 5.40002 8.00969 5.50055 7.99039 5.59755C7.9711 5.69454 7.92348 5.78363 7.85355 5.85355C7.78363 5.92348 7.69454 5.9711 7.59755 5.99039C7.50055 6.00969 7.40002 5.99978 7.30866 5.96194C7.2173 5.9241 7.13921 5.86001 7.08427 5.77779C7.02932 5.69556 7 5.59889 7 5.5C7 5.36739 7.05268 5.24021 7.14645 5.14645C7.24021 5.05268 7.36739 5 7.5 5Z"
          fill="url(#paint0_linear_1056_22216)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_22216"
            x1="3"
            y1="22.8095"
            x2="26.4902"
            y2="5.95455"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#683BB8" />
            <stop offset="1" stopColor="#A969FD" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  mediaBox: {
    colors: {
      background: 'linear-gradient(90deg, #BA2F2D 0%, #CA53F2 100%)',
      color: '#BA2F2D',
      icon: <UploadSimple size={20} weight="regular" color="#BA2F2D" />,
      iconFilled: <UploadSimple size={20} weight="fill" color="#BA2F2D" />,
    },
    nodeIcon: <UploadSimple size={20} weight="regular" color="#BA2F2D" />,
  },
  nodesGroup: {
    colors: colors.functions,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M9.5 2.5C9.5 2.63261 9.44732 2.75979 9.35355 2.85355C9.25979 2.94732 9.13261 3 9 3H7C6.86739 3 6.74021 2.94732 6.64645 2.85355C6.55268 2.75979 6.5 2.63261 6.5 2.5C6.5 2.36739 6.55268 2.24021 6.64645 2.14645C6.74021 2.05268 6.86739 2 7 2H9C9.13261 2 9.25979 2.05268 9.35355 2.14645C9.44732 2.24021 9.5 2.36739 9.5 2.5ZM9 13H7C6.86739 13 6.74021 13.0527 6.64645 13.1464C6.55268 13.2402 6.5 13.3674 6.5 13.5C6.5 13.6326 6.55268 13.7598 6.64645 13.8536C6.74021 13.9473 6.86739 14 7 14H9C9.13261 14 9.25979 13.9473 9.35355 13.8536C9.44732 13.7598 9.5 13.6326 9.5 13.5C9.5 13.3674 9.44732 13.2402 9.35355 13.1464C9.25979 13.0527 9.13261 13 9 13ZM13 3V4.5C13 4.63261 13.0527 4.75979 13.1464 4.85355C13.2402 4.94732 13.3674 5 13.5 5C13.6326 5 13.7598 4.94732 13.8536 4.85355C13.9473 4.75979 14 4.63261 14 4.5V3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2H11.5C11.3674 2 11.2402 2.05268 11.1464 2.14645C11.0527 2.24021 11 2.36739 11 2.5C11 2.63261 11.0527 2.75979 11.1464 2.85355C11.2402 2.94732 11.3674 3 11.5 3H13ZM13.5 6.5C13.3674 6.5 13.2402 6.55268 13.1464 6.64645C13.0527 6.74021 13 6.86739 13 7V9C13 9.13261 13.0527 9.25979 13.1464 9.35355C13.2402 9.44732 13.3674 9.5 13.5 9.5C13.6326 9.5 13.7598 9.44732 13.8536 9.35355C13.9473 9.25979 14 9.13261 14 9V7C14 6.86739 13.9473 6.74021 13.8536 6.64645C13.7598 6.55268 13.6326 6.5 13.5 6.5ZM2.5 9.5C2.63261 9.5 2.75979 9.44732 2.85355 9.35355C2.94732 9.25979 3 9.13261 3 9V7C3 6.86739 2.94732 6.74021 2.85355 6.64645C2.75979 6.55268 2.63261 6.5 2.5 6.5C2.36739 6.5 2.24021 6.55268 2.14645 6.64645C2.05268 6.74021 2 6.86739 2 7V9C2 9.13261 2.05268 9.25979 2.14645 9.35355C2.24021 9.44732 2.36739 9.5 2.5 9.5ZM4.5 13H3V11.5C3 11.3674 2.94732 11.2402 2.85355 11.1464C2.75979 11.0527 2.63261 11 2.5 11C2.36739 11 2.24021 11.0527 2.14645 11.1464C2.05268 11.2402 2 11.3674 2 11.5V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H4.5C4.63261 14 4.75979 13.9473 4.85355 13.8536C4.94732 13.7598 5 13.6326 5 13.5C5 13.3674 4.94732 13.2402 4.85355 13.1464C4.75979 13.0527 4.63261 13 4.5 13ZM4.5 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V4.5C2 4.63261 2.05268 4.75979 2.14645 4.85355C2.24021 4.94732 2.36739 5 2.5 5C2.63261 5 2.75979 4.94732 2.85355 4.85355C2.94732 4.75979 3 4.63261 3 4.5V3H4.5C4.63261 3 4.75979 2.94732 4.85355 2.85355C4.94732 2.75979 5 2.63261 5 2.5C5 2.36739 4.94732 2.24021 4.85355 2.14645C4.75979 2.05268 4.63261 2 4.5 2ZM15 13H14V12C14 11.8674 13.9473 11.7402 13.8536 11.6464C13.7598 11.5527 13.6326 11.5 13.5 11.5C13.3674 11.5 13.2402 11.5527 13.1464 11.6464C13.0527 11.7402 13 11.8674 13 12V13H12C11.8674 13 11.7402 13.0527 11.6464 13.1464C11.5527 13.2402 11.5 13.3674 11.5 13.5C11.5 13.6326 11.5527 13.7598 11.6464 13.8536C11.7402 13.9473 11.8674 14 12 14H13V15C13 15.1326 13.0527 15.2598 13.1464 15.3536C13.2402 15.4473 13.3674 15.5 13.5 15.5C13.6326 15.5 13.7598 15.4473 13.8536 15.3536C13.9473 15.2598 14 15.1326 14 15V14H15C15.1326 14 15.2598 13.9473 15.3536 13.8536C15.4473 13.7598 15.5 13.6326 15.5 13.5C15.5 13.3674 15.4473 13.2402 15.3536 13.1464C15.2598 13.0527 15.1326 13 15 13Z"
          fill='url(#paint0_linear_696_31608)"'
        />
        <defs>
          <linearGradient
            id="paint0_linear_696_31608"
            x1="5.62963"
            y1="24.5556"
            x2="27.6667"
            y2="9.77778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2BCCE1" />
            <stop offset="1" stopColor="#0ED2F7" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  arrayNode: {
    colors: colors.functions,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="16"
        viewBox="0 0 14 12"
        fill="none"
      >
        <path
          d="M11.5 7.5C11.0566 7.50042 10.6259 7.6479 10.2753 7.91934C9.92464 8.19077 9.67397 8.57084 9.5625 9H3.5C2.96957 9 2.46086 8.78929 2.08579 8.41421C1.71071 8.03914 1.5 7.53043 1.5 7C1.5 6.46957 1.71071 5.96086 2.08579 5.58579C2.46086 5.21071 2.96957 5 3.5 5H9.5C10.163 5 10.7989 4.73661 11.2678 4.26777C11.7366 3.79893 12 3.16304 12 2.5C12 1.83696 11.7366 1.20107 11.2678 0.732233C10.7989 0.263392 10.163 0 9.5 0H3.5C3.36739 0 3.24021 0.0526785 3.14645 0.146447C3.05268 0.240215 3 0.367392 3 0.5C3 0.632608 3.05268 0.759785 3.14645 0.853553C3.24021 0.947321 3.36739 1 3.5 1H9.5C9.89782 1 10.2794 1.15804 10.5607 1.43934C10.842 1.72064 11 2.10218 11 2.5C11 2.89782 10.842 3.27936 10.5607 3.56066C10.2794 3.84196 9.89782 4 9.5 4H3.5C2.70435 4 1.94129 4.31607 1.37868 4.87868C0.816071 5.44129 0.5 6.20435 0.5 7C0.5 7.79565 0.816071 8.55871 1.37868 9.12132C1.94129 9.68393 2.70435 10 3.5 10H9.5625C9.65601 10.3621 9.84919 10.6908 10.1201 10.9487C10.391 11.2066 10.7288 11.3833 11.0952 11.4588C11.4615 11.5343 11.8416 11.5056 12.1925 11.3759C12.5433 11.2462 12.8507 11.0208 13.0798 10.7251C13.3089 10.4295 13.4506 10.0756 13.4886 9.70347C13.5267 9.33138 13.4596 8.95608 13.2951 8.62019C13.1305 8.2843 12.8751 8.00128 12.5578 7.80327C12.2405 7.60526 11.874 7.50019 11.5 7.5ZM11.5 10.5C11.3022 10.5 11.1089 10.4414 10.9444 10.3315C10.78 10.2216 10.6518 10.0654 10.5761 9.88268C10.5004 9.69996 10.4806 9.49889 10.5192 9.30491C10.5578 9.11093 10.653 8.93275 10.7929 8.79289C10.9327 8.65304 11.1109 8.5578 11.3049 8.51921C11.4989 8.48063 11.7 8.50043 11.8827 8.57612C12.0654 8.65181 12.2216 8.77998 12.3315 8.94443C12.4414 9.10888 12.5 9.30222 12.5 9.5C12.5 9.76522 12.3946 10.0196 12.2071 10.2071C12.0196 10.3946 11.7652 10.5 11.5 10.5Z"
          fill="url(#paint0_linear_696_31608)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_696_31608"
            x1="5.62963"
            y1="24.5556"
            x2="27.6667"
            y2="9.77778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2BCCE1" />
            <stop offset="1" stopColor="#0ED2F7" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  webSearch: {
    colors: colors.web,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M14.825 9.49212C14.7833 9.3756 14.7342 9.26184 14.6781 9.15149L12.0787 3.23774C12.0542 3.18079 12.0189 3.12903 11.975 3.08524C11.7893 2.89948 11.5688 2.75212 11.3261 2.65158C11.0834 2.55104 10.8233 2.4993 10.5606 2.4993C10.2979 2.4993 10.0378 2.55104 9.79515 2.65158C9.55247 2.75212 9.33197 2.89948 9.14625 3.08524C9.05281 3.17879 9.00023 3.30553 9 3.43774V5.00024H7V3.43774C7.00005 3.37206 6.98716 3.30702 6.96207 3.24632C6.93697 3.18562 6.90017 3.13046 6.85375 3.08399C6.66803 2.89823 6.44753 2.75087 6.20485 2.65033C5.96217 2.54979 5.70206 2.49805 5.43938 2.49805C5.17669 2.49805 4.91658 2.54979 4.6739 2.65033C4.43122 2.75087 4.21072 2.89823 4.025 3.08399C3.98105 3.12778 3.94584 3.17954 3.92125 3.23649L1.32188 9.15024C1.2658 9.26059 1.21675 9.37435 1.175 9.49087C1.02781 9.90271 0.97245 10.3417 1.01279 10.7772C1.05313 11.2127 1.1882 11.6341 1.40853 12.0119C1.62886 12.3897 1.92913 12.7147 2.2883 12.9643C2.64747 13.2138 3.05686 13.3818 3.48778 13.4565C3.91871 13.5311 4.36075 13.5107 4.78294 13.3965C5.20513 13.2824 5.59726 13.0773 5.93186 12.7957C6.26646 12.5141 6.53543 12.1627 6.71994 11.7662C6.90446 11.3697 7.00004 10.9376 7 10.5002V6.00024H9V10.5002C8.99978 10.9376 9.09521 11.3698 9.2796 11.7664C9.46398 12.1631 9.73288 12.5146 10.0674 12.7964C10.402 13.0781 10.7941 13.2833 11.2163 13.3976C11.6385 13.5119 12.0806 13.5324 12.5116 13.4578C12.9426 13.3832 13.3521 13.2153 13.7113 12.9658C14.0706 12.7163 14.3709 12.3912 14.5913 12.0134C14.8117 11.6356 14.9468 11.2142 14.9872 10.7786C15.0276 10.3431 14.9722 9.904 14.825 9.49212ZM4.79438 3.73462C4.96108 3.59426 5.16906 3.51219 5.38669 3.50091C5.60432 3.48963 5.81968 3.54975 6 3.67212V8.26649C5.60963 7.91596 5.13399 7.67418 4.62074 7.56536C4.10749 7.45655 3.57466 7.48453 3.07563 7.64649L4.79438 3.73462ZM4 12.5002C3.60444 12.5002 3.21776 12.3829 2.88886 12.1632C2.55996 11.9434 2.30362 11.6311 2.15224 11.2656C2.00087 10.9002 1.96126 10.498 2.03843 10.1101C2.1156 9.7221 2.30608 9.36574 2.58579 9.08603C2.86549 8.80633 3.22186 8.61584 3.60982 8.53867C3.99778 8.4615 4.39991 8.50111 4.76537 8.65249C5.13082 8.80386 5.44318 9.06021 5.66294 9.3891C5.8827 9.718 6 10.1047 6 10.5002C6 11.0307 5.78929 11.5394 5.41421 11.9145C5.03914 12.2895 4.53043 12.5002 4 12.5002ZM10 3.67149C10.1803 3.54912 10.3957 3.48901 10.6133 3.50029C10.8309 3.51157 11.0389 3.59363 11.2056 3.73399L12.9244 7.64524C12.4253 7.48336 11.8924 7.45548 11.3792 7.56441C10.8659 7.67333 10.3903 7.91523 10 8.26587V3.67149ZM12 12.5002C11.6044 12.5002 11.2178 12.3829 10.8889 12.1632C10.56 11.9434 10.3036 11.6311 10.1522 11.2656C10.0009 10.9002 9.96126 10.498 10.0384 10.1101C10.1156 9.7221 10.3061 9.36574 10.5858 9.08603C10.8655 8.80633 11.2219 8.61584 11.6098 8.53867C11.9978 8.4615 12.3999 8.50111 12.7654 8.65249C13.1308 8.80386 13.4432 9.06021 13.6629 9.3891C13.8827 9.718 14 10.1047 14 10.5002C14 11.0307 13.7893 11.5394 13.4142 11.9145C13.0391 12.2895 12.5304 12.5002 12 12.5002Z"
          fill="url(#paint0_linear_1056_24923)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_24923"
            x1="6.61111"
            y1="23.2222"
            x2="26.1111"
            y2="8.77778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F857A6" />
            <stop offset="1" stopColor="#FF5858" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  webMedia: {
    colors: colors.web,
    nodeIcon: <></>,
  },
  webLocations: {
    colors: colors.web,
    nodeIcon: <></>,
  },
  webNews: {
    colors: colors.web,
    nodeIcon: <></>,
  },
  deepRefNode: {
    colors: colors.data,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M10.5 7H13.5C13.7652 7 14.0196 6.89464 14.2071 6.70711C14.3946 6.51957 14.5 6.26522 14.5 6V3C14.5 2.73478 14.3946 2.48043 14.2071 2.29289C14.0196 2.10536 13.7652 2 13.5 2H10.5C10.2348 2 9.98043 2.10536 9.79289 2.29289C9.60536 2.48043 9.5 2.73478 9.5 3V4H9C8.46957 4 7.96086 4.21071 7.58579 4.58579C7.21071 4.96086 7 5.46957 7 6V7.5H5V7C5 6.73478 4.89464 6.48043 4.70711 6.29289C4.51957 6.10536 4.26522 6 4 6H2C1.73478 6 1.48043 6.10536 1.29289 6.29289C1.10536 6.48043 1 6.73478 1 7V9C1 9.26522 1.10536 9.51957 1.29289 9.70711C1.48043 9.89464 1.73478 10 2 10H4C4.26522 10 4.51957 9.89464 4.70711 9.70711C4.89464 9.51957 5 9.26522 5 9V8.5H7V10C7 10.5304 7.21071 11.0391 7.58579 11.4142C7.96086 11.7893 8.46957 12 9 12H9.5V13C9.5 13.2652 9.60536 13.5196 9.79289 13.7071C9.98043 13.8946 10.2348 14 10.5 14H13.5C13.7652 14 14.0196 13.8946 14.2071 13.7071C14.3946 13.5196 14.5 13.2652 14.5 13V10C14.5 9.73478 14.3946 9.48043 14.2071 9.29289C14.0196 9.10536 13.7652 9 13.5 9H10.5C10.2348 9 9.98043 9.10536 9.79289 9.29289C9.60536 9.48043 9.5 9.73478 9.5 10V11H9C8.73478 11 8.48043 10.8946 8.29289 10.7071C8.10536 10.5196 8 10.2652 8 10V6C8 5.73478 8.10536 5.48043 8.29289 5.29289C8.48043 5.10536 8.73478 5 9 5H9.5V6C9.5 6.26522 9.60536 6.51957 9.79289 6.70711C9.98043 6.89464 10.2348 7 10.5 7ZM4 9H2V7H4V9ZM10.5 10H13.5V13H10.5V10ZM10.5 3H13.5V6H10.5V3Z"
          fill="url(#paint0_linear_1056_25983)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_25983"
            x1="8"
            y1="23.4286"
            x2="27.0053"
            y2="10.3407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF512F" />
            <stop offset="1" stopColor="#F09819" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  mathFunction: {
    colors: colors.functions,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M13 2.5C13 2.63261 12.9473 2.75979 12.8536 2.85355C12.7598 2.94732 12.6326 3 12.5 3H10.6694C10.318 2.99991 9.97772 3.12318 9.70792 3.34831C9.43813 3.57344 9.25594 3.88615 9.19312 4.23188L8.59937 7.5H11.5C11.6326 7.5 11.7598 7.55268 11.8536 7.64645C11.9473 7.74022 12 7.86739 12 8C12 8.13261 11.9473 8.25979 11.8536 8.35355C11.7598 8.44732 11.6326 8.5 11.5 8.5H8.4175L7.7925 11.9475C7.68764 12.5238 7.38372 13.0451 6.93377 13.4202C6.48382 13.7953 5.91643 14.0005 5.33063 14H3.5C3.36739 14 3.24021 13.9473 3.14645 13.8536C3.05268 13.7598 3 13.6326 3 13.5C3 13.3674 3.05268 13.2402 3.14645 13.1464C3.24021 13.0527 3.36739 13 3.5 13H5.33063C5.68201 13.0001 6.02228 12.8768 6.29208 12.6517C6.56187 12.4266 6.74406 12.1139 6.80688 11.7681L7.40063 8.5H4.5C4.36739 8.5 4.24021 8.44732 4.14645 8.35355C4.05268 8.25979 4 8.13261 4 8C4 7.86739 4.05268 7.74022 4.14645 7.64645C4.24021 7.55268 4.36739 7.5 4.5 7.5H7.5825L8.2075 4.0525C8.31236 3.47615 8.61628 2.95493 9.06623 2.57981C9.51618 2.20468 10.0836 1.99947 10.6694 2H12.5C12.6326 2 12.7598 2.05268 12.8536 2.14645C12.9473 2.24022 13 2.36739 13 2.5Z"
          fill="url(#paint0_linear_696_31608)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_696_31608"
            x1="5.62963"
            y1="24.5556"
            x2="27.6667"
            y2="9.77778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2BCCE1" />
            <stop offset="1" stopColor="#0ED2F7" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  scripting: {
    colors: colors.functions,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M2.4609 5.4891l-2.2-2.2a.55.55 90 010-.7783l2.2-2.2A.55.55 90 013.2391 1.0891L1.4276 2.9 3.2391 4.7109a.55.55 90 01-.7783.7783Zm2.75 0a.55.55 90 00.7783 0l2.2-2.2a.55.55 90 000-.7783l-2.2-2.2A.55.55 90 005.2109 1.0891L7.0224 2.9 5.2109 4.7109A.55.55 90 005.2109 5.4891ZM12.2 1.25H10.55a.55.55 90 000 1.1h1.65V12.25H2.3V7.85a.55.55 90 00-1.1 0v4.4a1.1 1.1 90 001.1 1.1H12.2a1.1 1.1 90 001.1-1.1V2.35A1.1 1.1 90 0012.2 1.25Z"
          fill="url(#paint0_linear_696_31608)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_696_31608"
            x1="5.62963"
            y1="24.5556"
            x2="27.6667"
            y2="9.77778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2BCCE1" />
            <stop offset="1" stopColor="#0ED2F7" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  counterNode: {
    colors: colors.functions,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M11 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V11C0 11.2652 0.105357 11.5196 0.292893 11.7071C0.48043 11.8946 0.734784 12 1 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11V1C12 0.734784 11.8946 0.48043 11.7071 0.292893C11.5196 0.105357 11.2652 0 11 0ZM11 11H1V1H11V11ZM8 7.25C7.99989 7.69688 7.8667 8.13361 7.61743 8.50451C7.36815 8.8754 7.01407 9.16367 6.60033 9.33256C6.18659 9.50145 5.73193 9.54331 5.29431 9.4528C4.85669 9.3623 4.45593 9.14352 4.14313 8.82438C4.09427 8.77815 4.05524 8.72255 4.02837 8.6609C4.0015 8.59924 3.98735 8.5328 3.98676 8.46554C3.98617 8.39829 3.99915 8.33161 4.02494 8.26949C4.05072 8.20737 4.08876 8.1511 4.1368 8.10402C4.18484 8.05695 4.24188 8.02006 4.30451 7.99555C4.36714 7.97103 4.43407 7.95941 4.5013 7.96137C4.56853 7.96333 4.63467 7.97883 4.69577 8.00694C4.75686 8.03506 4.81166 8.07521 4.85687 8.125C5.00113 8.27217 5.17952 8.38139 5.37619 8.44294C5.57286 8.50449 5.78169 8.51647 5.9841 8.4778C6.18652 8.43913 6.37623 8.35102 6.53636 8.22131C6.69649 8.09159 6.82206 7.9243 6.90191 7.73433C6.98176 7.54435 7.01339 7.33758 6.99401 7.13242C6.97463 6.92726 6.90482 6.73008 6.79081 6.55842C6.6768 6.38676 6.52211 6.24595 6.34052 6.14852C6.15893 6.05109 5.95607 6.00007 5.75 6C5.65853 5.99997 5.56883 5.97486 5.49064 5.92739C5.41246 5.87992 5.34879 5.81191 5.30658 5.73077C5.26436 5.64962 5.24522 5.55845 5.25122 5.46718C5.25722 5.37591 5.28815 5.28804 5.34062 5.21313L6.53938 3.5H4.5C4.36739 3.5 4.24021 3.44732 4.14645 3.35355C4.05268 3.25979 4 3.13261 4 3C4 2.86739 4.05268 2.74021 4.14645 2.64645C4.24021 2.55268 4.36739 2.5 4.5 2.5H7.5C7.59147 2.50003 7.68118 2.52514 7.75936 2.57261C7.83754 2.62008 7.90121 2.68809 7.94342 2.76923C7.98564 2.85038 8.00479 2.94155 7.99878 3.03282C7.99278 3.12409 7.96185 3.21196 7.90938 3.28687L6.59688 5.16187C7.0118 5.33107 7.36688 5.62009 7.6168 5.99201C7.86672 6.36394 8.00013 6.80191 8 7.25Z"
          fill="url(#paint0_linear_696_31608)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_696_31608"
            x1="5.62963"
            y1="24.5556"
            x2="27.6667"
            y2="9.77778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2BCCE1" />
            <stop offset="1" stopColor="#0ED2F7" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  tableProcessor: {
    colors: colors.data,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 13 12"
        fill="none"
      >
        <path
          d="M12.5 0H1.5C1.23478 0 0.98043 0.105357 0.792893 0.292893C0.605357 0.48043 0.5 0.734784 0.5 1V9C0.5 9.26522 0.605357 9.51957 0.792893 9.70711C0.98043 9.89464 1.23478 10 1.5 10H12.5C12.7652 10 13.0196 9.89464 13.2071 9.70711C13.3946 9.51957 13.5 9.26522 13.5 9V1C13.5 0.734784 13.3946 0.48043 13.2071 0.292893C13.0196 0.105357 12.7652 0 12.5 0ZM5.5 6V4H8.5V6H5.5ZM8.5 7V9H5.5V7H8.5ZM1.5 4H4.5V6H1.5V4ZM5.5 3V1H8.5V3H5.5ZM9.5 4H12.5V6H9.5V4ZM12.5 3H9.5V1H12.5V3ZM4.5 1V3H1.5V1H4.5ZM1.5 7H4.5V9H1.5V7ZM12.5 9H9.5V7H12.5V9Z"
          fill="#D0D5DD"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_25983"
            x1="8"
            y1="23.4286"
            x2="27.0053"
            y2="10.3407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF512F" />
            <stop offset="1" stopColor="#F09819" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  outputTable: {
    colors: colors.data,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M5 2H3.5C3.23478 2 2.98043 2.10536 2.79289 2.29289C2.60536 2.48043 2.5 2.73478 2.5 3V13C2.5 13.2652 2.60536 13.5196 2.79289 13.7071C2.98043 13.8946 3.23478 14 3.5 14H5C5.26522 14 5.51957 13.8946 5.70711 13.7071C5.89464 13.5196 6 13.2652 6 13V3C6 2.73478 5.89464 2.48043 5.70711 2.29289C5.51957 2.10536 5.26522 2 5 2ZM5 13H3.5V3H5V13ZM9.5 2H8C7.73478 2 7.48043 2.10536 7.29289 2.29289C7.10536 2.48043 7 2.73478 7 3V13C7 13.2652 7.10536 13.5196 7.29289 13.7071C7.48043 13.8946 7.73478 14 8 14H9.5C9.76522 14 10.0196 13.8946 10.2071 13.7071C10.3946 13.5196 10.5 13.2652 10.5 13V3C10.5 2.73478 10.3946 2.48043 10.2071 2.29289C10.0196 2.10536 9.76522 2 9.5 2ZM9.5 13H8V3H9.5V13ZM15.5 8C15.5 8.13261 15.4473 8.25979 15.3536 8.35355C15.2598 8.44732 15.1326 8.5 15 8.5H14V9.5C14 9.63261 13.9473 9.75979 13.8536 9.85355C13.7598 9.94732 13.6326 10 13.5 10C13.3674 10 13.2402 9.94732 13.1464 9.85355C13.0527 9.75979 13 9.63261 13 9.5V8.5H12C11.8674 8.5 11.7402 8.44732 11.6464 8.35355C11.5527 8.25979 11.5 8.13261 11.5 8C11.5 7.86739 11.5527 7.74021 11.6464 7.64645C11.7402 7.55268 11.8674 7.5 12 7.5H13V6.5C13 6.36739 13.0527 6.24021 13.1464 6.14645C13.2402 6.05268 13.3674 6 13.5 6C13.6326 6 13.7598 6.05268 13.8536 6.14645C13.9473 6.24021 14 6.36739 14 6.5V7.5H15C15.1326 7.5 15.2598 7.55268 15.3536 7.64645C15.4473 7.74021 15.5 7.86739 15.5 8Z"
          fill="url(#paint0_linear_1056_25983)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_25983"
            x1="8"
            y1="23.4286"
            x2="27.0053"
            y2="10.3407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF512F" />
            <stop offset="1" stopColor="#F09819" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  dynamicSettingsNode: {
    colors: colors.functions,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M2.5 5.50002H4.5625C4.67265 5.93022 4.92285 6.31153 5.27365 6.58384C5.62446 6.85614 6.05591 7.00394 6.5 7.00394C6.94409 7.00394 7.37554 6.85614 7.72635 6.58384C8.07715 6.31153 8.32735 5.93022 8.4375 5.50002H13.5C13.6326 5.50002 13.7598 5.44734 13.8536 5.35357C13.9473 5.2598 14 5.13262 14 5.00002C14 4.86741 13.9473 4.74023 13.8536 4.64646C13.7598 4.55269 13.6326 4.50002 13.5 4.50002H8.4375C8.32735 4.06981 8.07715 3.6885 7.72635 3.4162C7.37554 3.14389 6.94409 2.99609 6.5 2.99609C6.05591 2.99609 5.62446 3.14389 5.27365 3.4162C4.92285 3.6885 4.67265 4.06981 4.5625 4.50002H2.5C2.36739 4.50002 2.24021 4.55269 2.14645 4.64646C2.05268 4.74023 2 4.86741 2 5.00002C2 5.13262 2.05268 5.2598 2.14645 5.35357C2.24021 5.44734 2.36739 5.50002 2.5 5.50002ZM6.5 4.00002C6.69778 4.00002 6.89112 4.05866 7.05557 4.16855C7.22002 4.27843 7.34819 4.43461 7.42388 4.61733C7.49957 4.80006 7.51937 5.00112 7.48079 5.19511C7.4422 5.38909 7.34696 5.56727 7.20711 5.70712C7.06725 5.84697 6.88907 5.94222 6.69509 5.9808C6.50111 6.01939 6.30004 5.99958 6.11732 5.9239C5.93459 5.84821 5.77841 5.72003 5.66853 5.55559C5.55865 5.39114 5.5 5.1978 5.5 5.00002C5.5 4.7348 5.60536 4.48045 5.79289 4.29291C5.98043 4.10537 6.23478 4.00002 6.5 4.00002ZM13.5 10.5H12.4375C12.3273 10.0698 12.0771 9.6885 11.7263 9.4162C11.3755 9.1439 10.9441 8.99609 10.5 8.99609C10.0559 8.99609 9.62446 9.1439 9.27365 9.4162C8.92285 9.6885 8.67265 10.0698 8.5625 10.5H2.5C2.36739 10.5 2.24021 10.5527 2.14645 10.6465C2.05268 10.7402 2 10.8674 2 11C2 11.1326 2.05268 11.2598 2.14645 11.3536C2.24021 11.4473 2.36739 11.5 2.5 11.5H8.5625C8.67265 11.9302 8.92285 12.3115 9.27365 12.5838C9.62446 12.8561 10.0559 13.0039 10.5 13.0039C10.9441 13.0039 11.3755 12.8561 11.7263 12.5838C12.0771 12.3115 12.3273 11.9302 12.4375 11.5H13.5C13.6326 11.5 13.7598 11.4473 13.8536 11.3536C13.9473 11.2598 14 11.1326 14 11C14 10.8674 13.9473 10.7402 13.8536 10.6465C13.7598 10.5527 13.6326 10.5 13.5 10.5ZM10.5 12C10.3022 12 10.1089 11.9414 9.94443 11.8315C9.77998 11.7216 9.65181 11.5654 9.57612 11.3827C9.50043 11.2 9.48063 10.9989 9.51921 10.8049C9.5578 10.6109 9.65304 10.4328 9.79289 10.2929C9.93275 10.1531 10.1109 10.0578 10.3049 10.0192C10.4989 9.98064 10.7 10.0004 10.8827 10.0761C11.0654 10.1518 11.2216 10.28 11.3315 10.4444C11.4414 10.6089 11.5 10.8022 11.5 11C11.5 11.2652 11.3946 11.5196 11.2071 11.7071C11.0196 11.8947 10.7652 12 10.5 12Z"
          fill="url(#paint0_linear_696_31608)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_696_31608"
            x1="5.62963"
            y1="24.5556"
            x2="27.6667"
            y2="9.77778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2BCCE1" />
            <stop offset="1" stopColor="#0ED2F7" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  audioReaderNode: {
    colors: colors.audio,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M3.5 6V10C3.5 10.1326 3.44732 10.2598 3.35355 10.3536C3.25979 10.4473 3.13261 10.5 3 10.5C2.86739 10.5 2.74021 10.4473 2.64645 10.3536C2.55268 10.2598 2.5 10.1326 2.5 10V6C2.5 5.86739 2.55268 5.74021 2.64645 5.64645C2.74021 5.55268 2.86739 5.5 3 5.5C3.13261 5.5 3.25979 5.55268 3.35355 5.64645C3.44732 5.74021 3.5 5.86739 3.5 6ZM5.5 1.5C5.36739 1.5 5.24021 1.55268 5.14645 1.64645C5.05268 1.74021 5 1.86739 5 2V14C5 14.1326 5.05268 14.2598 5.14645 14.3536C5.24021 14.4473 5.36739 14.5 5.5 14.5C5.63261 14.5 5.75979 14.4473 5.85355 14.3536C5.94732 14.2598 6 14.1326 6 14V2C6 1.86739 5.94732 1.74021 5.85355 1.64645C5.75979 1.55268 5.63261 1.5 5.5 1.5ZM8 3.5C7.86739 3.5 7.74021 3.55268 7.64645 3.64645C7.55268 3.74021 7.5 3.86739 7.5 4V12C7.5 12.1326 7.55268 12.2598 7.64645 12.3536C7.74021 12.4473 7.86739 12.5 8 12.5C8.13261 12.5 8.25979 12.4473 8.35355 12.3536C8.44732 12.2598 8.5 12.1326 8.5 12V4C8.5 3.86739 8.44732 3.74021 8.35355 3.64645C8.25979 3.55268 8.13261 3.5 8 3.5ZM10.5 5.5C10.3674 5.5 10.2402 5.55268 10.1464 5.64645C10.0527 5.74021 10 5.86739 10 6V10C10 10.1326 10.0527 10.2598 10.1464 10.3536C10.2402 10.4473 10.3674 10.5 10.5 10.5C10.6326 10.5 10.7598 10.4473 10.8536 10.3536C10.9473 10.2598 11 10.1326 11 10V6C11 5.86739 10.9473 5.74021 10.8536 5.64645C10.7598 5.55268 10.6326 5.5 10.5 5.5ZM13 4.5C12.8674 4.5 12.7402 4.55268 12.6464 4.64645C12.5527 4.74021 12.5 4.86739 12.5 5V11C12.5 11.1326 12.5527 11.2598 12.6464 11.3536C12.7402 11.4473 12.8674 11.5 13 11.5C13.1326 11.5 13.2598 11.4473 13.3536 11.3536C13.4473 11.2598 13.5 11.1326 13.5 11V5C13.5 4.86739 13.4473 4.74021 13.3536 4.64645C13.2598 4.55268 13.1326 4.5 13 4.5Z"
          fill="url(#paint0_linear_1056_24276)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_24276"
            x1="6.725"
            y1="26.7244"
            x2="28.6558"
            y2="15.3368"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#73E49A" />
            <stop offset="0.989583" stopColor="#3FC36D" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  commandMusicNode: {
    colors: colors.audio,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M13.3075 1.10559C13.2476 1.05893 13.1779 1.02651 13.1036 1.01081C13.0293 0.995106 12.9524 0.996529 12.8788 1.01497L4.87875 3.01497C4.77058 3.04201 4.67455 3.10443 4.60593 3.1923C4.5373 3.28018 4.50002 3.38847 4.5 3.49997V10.38C4.0829 10.1013 3.58462 9.96997 3.08434 10.0069C2.58407 10.0438 2.11048 10.2469 1.73882 10.5838C1.36716 10.9207 1.11876 11.3722 1.03307 11.8665C0.947383 12.3607 1.02933 12.8695 1.26589 13.3118C1.50244 13.7542 1.88004 14.1048 2.3387 14.308C2.79735 14.5112 3.31075 14.5552 3.79732 14.4332C4.28389 14.3112 4.71573 14.0301 5.02423 13.6345C5.33273 13.2389 5.50019 12.7516 5.5 12.25V6.89059L12.5 5.14059V8.37997C12.0829 8.10128 11.5846 7.96997 11.0843 8.00691C10.5841 8.04384 10.1105 8.2469 9.73882 8.58382C9.36716 8.92074 9.11876 9.3722 9.03307 9.86646C8.94738 10.3607 9.02933 10.8695 9.26589 11.3118C9.50244 11.7542 9.88004 12.1048 10.3387 12.308C10.7974 12.5112 11.3107 12.5552 11.7973 12.4332C12.2839 12.3112 12.7157 12.0301 13.0242 11.6345C13.3327 11.2389 13.5002 10.7516 13.5 10.25V1.49997C13.5 1.42392 13.4827 1.34887 13.4493 1.28053C13.416 1.21219 13.3675 1.15236 13.3075 1.10559ZM3.25 13.5C3.00278 13.5 2.7611 13.4267 2.55554 13.2893C2.34998 13.152 2.18976 12.9567 2.09515 12.7283C2.00054 12.4999 1.97579 12.2486 2.02402 12.0061C2.07225 11.7636 2.1913 11.5409 2.36612 11.3661C2.54094 11.1913 2.76366 11.0722 3.00614 11.024C3.24862 10.9758 3.49995 11.0005 3.72836 11.0951C3.95676 11.1897 4.15199 11.3499 4.28934 11.5555C4.42669 11.7611 4.5 12.0027 4.5 12.25C4.5 12.5815 4.36831 12.8994 4.13389 13.1339C3.89947 13.3683 3.58152 13.5 3.25 13.5ZM5.5 5.85934V3.89059L12.5 2.14059V4.10934L5.5 5.85934ZM11.25 11.5C11.0028 11.5 10.7611 11.4267 10.5555 11.2893C10.35 11.152 10.1898 10.9567 10.0952 10.7283C10.0005 10.4999 9.97579 10.2486 10.024 10.0061C10.0723 9.76363 10.1913 9.5409 10.3661 9.36609C10.5409 9.19127 10.7637 9.07222 11.0061 9.02399C11.2486 8.97576 11.4999 9.00051 11.7284 9.09512C11.9568 9.18973 12.152 9.34995 12.2893 9.55551C12.4267 9.76107 12.5 10.0027 12.5 10.25C12.5 10.5815 12.3683 10.8994 12.1339 11.1339C11.8995 11.3683 11.5815 11.5 11.25 11.5Z"
          fill="url(#paint0_linear_1056_24276)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_24276"
            x1="6.725"
            y1="26.7244"
            x2="28.6558"
            y2="15.3368"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#73E49A" />
            <stop offset="0.989583" stopColor="#3FC36D" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  apiCaller: {
    colors: colors.external,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M10.2574 5.99991C11.798 3.83678 12.5837 1.60116 11.4912 0.508658C10.3987 -0.583842 8.16303 0.201783 5.99991 1.74241C3.83678 0.201783 1.60116 -0.583842 0.508658 0.508658C-0.583842 1.60116 0.201783 3.83678 1.74241 5.99991C0.201783 8.16303 -0.583842 10.3987 0.508658 11.4912C0.860533 11.843 1.33053 11.9999 1.87803 11.9999C3.03303 11.9999 4.53303 11.3018 6.00303 10.2574C7.46678 11.3018 8.96678 11.9999 10.1249 11.9999C10.6724 11.9999 11.143 11.8424 11.4943 11.4912C12.5837 10.3987 11.798 8.16303 10.2574 5.99991ZM10.7843 1.21553C11.2618 1.69303 10.9393 3.24053 9.62678 5.17053C9.21156 4.65652 8.76949 4.1648 8.30241 3.69741C7.83497 3.23097 7.34325 2.78952 6.82928 2.37491C8.75928 1.06241 10.3068 0.737408 10.7843 1.21553ZM9.01803 5.99991C8.57577 6.55939 8.10077 7.09219 7.59553 7.59553C7.09219 8.10077 6.55939 8.57577 5.99991 9.01803C5.44043 8.57577 4.90762 8.10077 4.40428 7.59553C3.89905 7.09219 3.42405 6.55939 2.98178 5.99991C3.8691 4.88176 4.88176 3.8691 5.99991 2.98178C6.55939 3.42405 7.09219 3.89905 7.59553 4.40428C8.10077 4.90762 8.57577 5.44043 9.01803 5.99991ZM1.21553 1.21553C1.35303 1.07741 1.57991 1.00616 1.87928 1.00616C2.61803 1.00616 3.79741 1.43741 5.16991 2.37491C4.65643 2.78986 4.16493 3.23129 3.69741 3.69741C3.23097 4.16484 2.78952 4.65657 2.37491 5.17053C1.06241 3.24053 0.738033 1.69303 1.21553 1.21553ZM1.21553 10.7843C0.738033 10.3068 1.06241 8.75928 2.37491 6.82928C2.79013 7.34329 3.2322 7.83502 3.69928 8.30241C4.16642 8.76848 4.6575 9.20991 5.17053 9.62491C3.24053 10.9374 1.69303 11.2624 1.21553 10.7843ZM10.7843 10.7843C10.3068 11.2624 8.75928 10.9393 6.82928 9.62678C7.34301 9.21122 7.83471 8.76917 8.30241 8.30241C8.76885 7.83497 9.21029 7.34325 9.62491 6.82928C10.9374 8.75928 11.2618 10.3068 10.7843 10.7843ZM6.74991 5.99991C6.74991 6.14824 6.70592 6.29325 6.62351 6.41658C6.5411 6.53992 6.42396 6.63605 6.28692 6.69282C6.14988 6.74958 5.99908 6.76444 5.85359 6.7355C5.7081 6.70656 5.57447 6.63513 5.46958 6.53024C5.36469 6.42535 5.29326 6.29171 5.26432 6.14622C5.23538 6.00074 5.25023 5.84994 5.307 5.71289C5.36376 5.57585 5.45989 5.45872 5.58323 5.37631C5.70657 5.29389 5.85157 5.24991 5.99991 5.24991C6.19882 5.24991 6.38958 5.32893 6.53024 5.46958C6.67089 5.61023 6.74991 5.801 6.74991 5.99991Z"
          fill="url(#paint0_linear_537_24169)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_537_24169"
            x1="3.33336"
            y1="23.4668"
            x2="23.8892"
            y2="4.37212"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0572917" stopColor="#FD746C" />
            <stop offset="0.494792" stopColor="#FE846A" />
            <stop offset="0.932292" stopColor="#FF9068" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  mcpNode: {
    colors: colors.external,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
          fill="url(#paint0_linear_mcp)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_mcp"
            x1="2"
            y1="2"
            x2="22"
            y2="22"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0572917" stopColor="#FD746C" />
            <stop offset="0.494792" stopColor="#FE846A" />
            <stop offset="0.932292" stopColor="#FF9068" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  imageReaderNode: {
    colors: colors.image,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M12.5 5V7C12.5 7.13261 12.4473 7.25979 12.3536 7.35355C12.2598 7.44732 12.1326 7.5 12 7.5C11.8674 7.5 11.7402 7.44732 11.6464 7.35355C11.5527 7.25979 11.5 7.13261 11.5 7V5.5H10C9.86739 5.5 9.74021 5.44732 9.64645 5.35355C9.55268 5.25979 9.5 5.13261 9.5 5C9.5 4.86739 9.55268 4.74021 9.64645 4.64645C9.74021 4.55268 9.86739 4.5 10 4.5H12C12.1326 4.5 12.2598 4.55268 12.3536 4.64645C12.4473 4.74021 12.5 4.86739 12.5 5ZM6 10.5H4.5V9C4.5 8.86739 4.44732 8.74021 4.35355 8.64645C4.25979 8.55268 4.13261 8.5 4 8.5C3.86739 8.5 3.74021 8.55268 3.64645 8.64645C3.55268 8.74021 3.5 8.86739 3.5 9V11C3.5 11.1326 3.55268 11.2598 3.64645 11.3536C3.74021 11.4473 3.86739 11.5 4 11.5H6C6.13261 11.5 6.25979 11.4473 6.35355 11.3536C6.44732 11.2598 6.5 11.1326 6.5 11C6.5 10.8674 6.44732 10.7402 6.35355 10.6464C6.25979 10.5527 6.13261 10.5 6 10.5ZM14.5 3.5V12.5C14.5 12.7652 14.3946 13.0196 14.2071 13.2071C14.0196 13.3946 13.7652 13.5 13.5 13.5H2.5C2.23478 13.5 1.98043 13.3946 1.79289 13.2071C1.60536 13.0196 1.5 12.7652 1.5 12.5V3.5C1.5 3.23478 1.60536 2.98043 1.79289 2.79289C1.98043 2.60536 2.23478 2.5 2.5 2.5H13.5C13.7652 2.5 14.0196 2.60536 14.2071 2.79289C14.3946 2.98043 14.5 3.23478 14.5 3.5ZM13.5 12.5V3.5H2.5V12.5H13.5Z"
          fill="url(#paint0_linear_1056_22216)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_22216"
            x1="3"
            y1="22.8095"
            x2="26.4902"
            y2="5.95455"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#683BB8" />
            <stop offset="1" stopColor="#A969FD" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  webCrawling: {
    colors: colors.web,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M2 4C2 3.86739 2.05268 3.74021 2.14645 3.64645C2.24021 3.55268 2.36739 3.5 2.5 3.5H13.5C13.6326 3.5 13.7598 3.55268 13.8536 3.64645C13.9473 3.74021 14 3.86739 14 4C14 4.13261 13.9473 4.25979 13.8536 4.35355C13.7598 4.44732 13.6326 4.5 13.5 4.5H2.5C2.36739 4.5 2.24021 4.44732 2.14645 4.35355C2.05268 4.25979 2 4.13261 2 4ZM2.5 8.5H7C7.13261 8.5 7.25979 8.44732 7.35355 8.35355C7.44732 8.25979 7.5 8.13261 7.5 8C7.5 7.86739 7.44732 7.74021 7.35355 7.64645C7.25979 7.55268 7.13261 7.5 7 7.5H2.5C2.36739 7.5 2.24021 7.55268 2.14645 7.64645C2.05268 7.74021 2 7.86739 2 8C2 8.13261 2.05268 8.25979 2.14645 8.35355C2.24021 8.44732 2.36739 8.5 2.5 8.5ZM8 11.5H2.5C2.36739 11.5 2.24021 11.5527 2.14645 11.6464C2.05268 11.7402 2 11.8674 2 12C2 12.1326 2.05268 12.2598 2.14645 12.3536C2.24021 12.4473 2.36739 12.5 2.5 12.5H8C8.13261 12.5 8.25979 12.4473 8.35355 12.3536C8.44732 12.2598 8.5 12.1326 8.5 12C8.5 11.8674 8.44732 11.7402 8.35355 11.6464C8.25979 11.5527 8.13261 11.5 8 11.5ZM14.8538 12.3538C14.8073 12.4002 14.7522 12.4371 14.6915 12.4623C14.6308 12.4874 14.5657 12.5004 14.5 12.5004C14.4343 12.5004 14.3692 12.4874 14.3085 12.4623C14.2478 12.4371 14.1927 12.4002 14.1462 12.3538L12.875 11.085C12.358 11.4261 11.7328 11.5631 11.1206 11.4696C10.5083 11.376 9.95261 11.0585 9.56109 10.5786C9.16958 10.0987 8.97014 9.4905 9.00144 8.87193C9.03273 8.25336 9.29253 7.66843 9.73048 7.23048C10.1684 6.79253 10.7534 6.53273 11.3719 6.50144C11.9905 6.47014 12.5987 6.66958 13.0786 7.06109C13.5585 7.45261 13.876 8.00833 13.9696 8.62058C14.0631 9.23284 13.9261 9.85802 13.585 10.375L14.8538 11.6438C14.9006 11.6902 14.9378 11.7455 14.9632 11.8065C14.9886 11.8674 15.0016 11.9327 15.0016 11.9987C15.0016 12.0648 14.9886 12.1301 14.9632 12.191C14.9378 12.252 14.9006 12.3073 14.8538 12.3538ZM11.5 10.5C11.7967 10.5 12.0867 10.412 12.3334 10.2472C12.58 10.0824 12.7723 9.84811 12.8858 9.57403C12.9994 9.29994 13.0291 8.99834 12.9712 8.70736C12.9133 8.41639 12.7704 8.14912 12.5607 7.93934C12.3509 7.72956 12.0836 7.5867 11.7926 7.52882C11.5017 7.47094 11.2001 7.50065 10.926 7.61418C10.6519 7.72771 10.4176 7.91997 10.2528 8.16665C10.088 8.41332 10 8.70333 10 9C10 9.39782 10.158 9.77936 10.4393 10.0607C10.7206 10.342 11.1022 10.5 11.5 10.5Z"
          fill="url(#paint0_linear_1056_24923)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_24923"
            x1="6.61111"
            y1="23.2222"
            x2="26.1111"
            y2="8.77778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F857A6" />
            <stop offset="1" stopColor="#FF5858" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  webTrends: {
    colors: colors.web,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M15.0003 3.5V7.5C15.0003 7.63261 14.9476 7.75979 14.8538 7.85355C14.7601 7.94732 14.6329 8 14.5003 8C14.3677 8 14.2405 7.94732 14.1467 7.85355C14.053 7.75979 14.0003 7.63261 14.0003 7.5V4.70687L8.85403 9.85375C8.80759 9.90024 8.75245 9.93712 8.69175 9.96228C8.63105 9.98744 8.56599 10.0004 8.50028 10.0004C8.43457 10.0004 8.36951 9.98744 8.30881 9.96228C8.24811 9.93712 8.19296 9.90024 8.14653 9.85375L6.00028 7.70687L1.85403 11.8538C1.76021 11.9476 1.63296 12.0003 1.50028 12.0003C1.3676 12.0003 1.24035 11.9476 1.14653 11.8538C1.05271 11.7599 1 11.6327 1 11.5C1 11.3673 1.05271 11.2401 1.14653 11.1462L5.64653 6.64625C5.69296 6.59976 5.74811 6.56288 5.80881 6.53772C5.86951 6.51256 5.93457 6.49961 6.00028 6.49961C6.06599 6.49961 6.13105 6.51256 6.19175 6.53772C6.25245 6.56288 6.30759 6.59976 6.35403 6.64625L8.50028 8.79313L13.2934 4H10.5003C10.3677 4 10.2405 3.94732 10.1467 3.85355C10.053 3.75979 10.0003 3.63261 10.0003 3.5C10.0003 3.36739 10.053 3.24021 10.1467 3.14645C10.2405 3.05268 10.3677 3 10.5003 3H14.5003C14.6329 3 14.7601 3.05268 14.8538 3.14645C14.9476 3.24021 15.0003 3.36739 15.0003 3.5Z"
          fill="url(#paint0_linear_1056_24923)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_24923"
            x1="6.61111"
            y1="23.2222"
            x2="26.1111"
            y2="8.77778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F857A6" />
            <stop offset="1" stopColor="#FF5858" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  animationNode: {
    colors: colors.image,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M10.2775 6.58375L7.2775 4.58375C7.20218 4.5335 7.11463 4.50464 7.0242 4.50026C6.93376 4.49588 6.84383 4.51614 6.76401 4.55887C6.68418 4.60161 6.61746 4.66521 6.57097 4.74291C6.52447 4.8206 6.49994 4.90946 6.5 5V9C6.49994 9.09054 6.52447 9.1794 6.57097 9.25709C6.61746 9.33478 6.68418 9.39839 6.76401 9.44113C6.84383 9.48386 6.93376 9.50412 7.0242 9.49974C7.11463 9.49536 7.20218 9.4665 7.2775 9.41625L10.2775 7.41625C10.3461 7.37061 10.4023 7.30873 10.4412 7.23611C10.4801 7.16349 10.5005 7.08238 10.5005 7C10.5005 6.91762 10.4801 6.83651 10.4412 6.76389C10.4023 6.69127 10.3461 6.62939 10.2775 6.58375ZM7.5 8.06563V5.9375L9.09875 7L7.5 8.06563ZM13.5 2.5H2.5C2.23478 2.5 1.98043 2.60536 1.79289 2.79289C1.60536 2.98043 1.5 3.23478 1.5 3.5V10.5C1.5 10.7652 1.60536 11.0196 1.79289 11.2071C1.98043 11.3946 2.23478 11.5 2.5 11.5H13.5C13.7652 11.5 14.0196 11.3946 14.2071 11.2071C14.3946 11.0196 14.5 10.7652 14.5 10.5V3.5C14.5 3.23478 14.3946 2.98043 14.2071 2.79289C14.0196 2.60536 13.7652 2.5 13.5 2.5ZM13.5 10.5H2.5V3.5H13.5V10.5ZM14.5 13C14.5 13.1326 14.4473 13.2598 14.3536 13.3536C14.2598 13.4473 14.1326 13.5 14 13.5H2C1.86739 13.5 1.74021 13.4473 1.64645 13.3536C1.55268 13.2598 1.5 13.1326 1.5 13C1.5 12.8674 1.55268 12.7402 1.64645 12.6464C1.74021 12.5527 1.86739 12.5 2 12.5H14C14.1326 12.5 14.2598 12.5527 14.3536 12.6464C14.4473 12.7402 14.5 12.8674 14.5 13Z"
          fill="url(#paint0_linear_1056_22216)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_22216"
            x1="3"
            y1="22.8095"
            x2="26.4902"
            y2="5.95455"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#683BB8" />
            <stop offset="1" stopColor="#A969FD" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  usCensusNode: {
    colors: colors.web,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M12.5 7C12.5 7.13261 12.4473 7.25979 12.3536 7.35355C12.2598 7.44732 12.1326 7.5 12 7.5H9.5C9.36739 7.5 9.24021 7.44732 9.14645 7.35355C9.05268 7.25979 9 7.13261 9 7C9 6.86739 9.05268 6.74021 9.14645 6.64645C9.24021 6.55268 9.36739 6.5 9.5 6.5H12C12.1326 6.5 12.2598 6.55268 12.3536 6.64645C12.4473 6.74021 12.5 6.86739 12.5 7ZM12 8.5H9.5C9.36739 8.5 9.24021 8.55268 9.14645 8.64645C9.05268 8.74021 9 8.86739 9 9C9 9.13261 9.05268 9.25979 9.14645 9.35355C9.24021 9.44732 9.36739 9.5 9.5 9.5H12C12.1326 9.5 12.2598 9.44732 12.3536 9.35355C12.4473 9.25979 12.5 9.13261 12.5 9C12.5 8.86739 12.4473 8.74021 12.3536 8.64645C12.2598 8.55268 12.1326 8.5 12 8.5ZM14.5 3.5V12.5C14.5 12.7652 14.3946 13.0196 14.2071 13.2071C14.0196 13.3946 13.7652 13.5 13.5 13.5H2.5C2.23478 13.5 1.98043 13.3946 1.79289 13.2071C1.60536 13.0196 1.5 12.7652 1.5 12.5V3.5C1.5 3.23478 1.60536 2.98043 1.79289 2.79289C1.98043 2.60536 2.23478 2.5 2.5 2.5H13.5C13.7652 2.5 14.0196 2.60536 14.2071 2.79289C14.3946 2.98043 14.5 3.23478 14.5 3.5ZM13.5 12.5V3.5H2.5V12.5H13.5ZM8.48375 10.375C8.5169 10.5035 8.49766 10.6398 8.43027 10.7541C8.36287 10.8684 8.25284 10.9512 8.12438 10.9844C7.99591 11.0175 7.85954 10.9983 7.74526 10.9309C7.63098 10.8635 7.54815 10.7535 7.515 10.625C7.35063 9.98375 6.69875 9.5 5.99937 9.5C5.3 9.5 4.64875 9.98375 4.48375 10.625C4.4506 10.7535 4.36777 10.8635 4.25349 10.9309C4.13921 10.9983 4.00284 11.0175 3.87438 10.9844C3.74591 10.9512 3.63588 10.8684 3.56848 10.7541C3.50109 10.6398 3.48185 10.5035 3.515 10.375C3.67725 9.77109 4.06078 9.25034 4.58938 8.91625C4.30848 8.63702 4.11682 8.28068 4.03868 7.89239C3.96054 7.50411 3.99945 7.10136 4.15048 6.73522C4.3015 6.36907 4.55784 6.05601 4.887 5.83572C5.21615 5.61543 5.60331 5.49784 5.99937 5.49784C6.39544 5.49784 6.7826 5.61543 7.11175 5.83572C7.44091 6.05601 7.69725 6.36907 7.84827 6.73522C7.9993 7.10136 8.03821 7.50411 7.96007 7.89239C7.88193 8.28068 7.69027 8.63702 7.40938 8.91625C7.93854 9.24986 8.32242 9.77078 8.48438 10.375H8.48375ZM6 8.5C6.19778 8.5 6.39112 8.44135 6.55557 8.33147C6.72002 8.22159 6.84819 8.06541 6.92388 7.88268C6.99957 7.69996 7.01937 7.49889 6.98079 7.30491C6.9422 7.11093 6.84696 6.93275 6.70711 6.79289C6.56725 6.65304 6.38907 6.5578 6.19509 6.51921C6.00111 6.48063 5.80004 6.50043 5.61732 6.57612C5.43459 6.65181 5.27841 6.77998 5.16853 6.94443C5.05865 7.10888 5 7.30222 5 7.5C5 7.76522 5.10536 8.01957 5.29289 8.20711C5.48043 8.39464 5.73478 8.5 6 8.5Z"
          fill="url(#paint0_linear_1056_24923)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_24923"
            x1="6.61111"
            y1="23.2222"
            x2="26.1111"
            y2="8.77778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F857A6" />
            <stop offset="1" stopColor="#FF5858" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  documentSummarizer: {
    colors: colors.data,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 12 10"
        fill="none"
      >
        <path
          d="M3 1C3 0.867392 3.05268 0.740215 3.14645 0.646447C3.24022 0.552679 3.36739 0.5 3.5 0.5H11.5C11.6326 0.5 11.7598 0.552679 11.8536 0.646447C11.9473 0.740215 12 0.867392 12 1C12 1.13261 11.9473 1.25979 11.8536 1.35355C11.7598 1.44732 11.6326 1.5 11.5 1.5H3.5C3.36739 1.5 3.24022 1.44732 3.14645 1.35355C3.05268 1.25979 3 1.13261 3 1ZM11.5 4.5H3.5C3.36739 4.5 3.24022 4.55268 3.14645 4.64645C3.05268 4.74021 3 4.86739 3 5C3 5.13261 3.05268 5.25979 3.14645 5.35355C3.24022 5.44732 3.36739 5.5 3.5 5.5H11.5C11.6326 5.5 11.7598 5.44732 11.8536 5.35355C11.9473 5.25979 12 5.13261 12 5C12 4.86739 11.9473 4.74021 11.8536 4.64645C11.7598 4.55268 11.6326 4.5 11.5 4.5ZM11.5 8.5H3.5C3.36739 8.5 3.24022 8.55268 3.14645 8.64645C3.05268 8.74021 3 8.86739 3 9C3 9.13261 3.05268 9.25979 3.14645 9.35355C3.24022 9.44732 3.36739 9.5 3.5 9.5H11.5C11.6326 9.5 11.7598 9.44732 11.8536 9.35355C11.9473 9.25979 12 9.13261 12 9C12 8.86739 11.9473 8.74021 11.8536 8.64645C11.7598 8.55268 11.6326 8.5 11.5 8.5ZM0.75 0.25C0.601664 0.25 0.45666 0.293987 0.333323 0.376398C0.209986 0.458809 0.113856 0.575943 0.0570907 0.712987C0.000324965 0.850032 -0.0145275 1.00083 0.0144114 1.14632C0.0433503 1.2918 0.114781 1.42544 0.21967 1.53033C0.32456 1.63522 0.458197 1.70665 0.603683 1.73559C0.749168 1.76453 0.899968 1.74968 1.03701 1.69291C1.17406 1.63614 1.29119 1.54001 1.3736 1.41668C1.45601 1.29334 1.5 1.14834 1.5 1C1.5 0.801088 1.42098 0.610322 1.28033 0.46967C1.13968 0.329018 0.948913 0.25 0.75 0.25ZM0.75 4.25C0.601664 4.25 0.45666 4.29399 0.333323 4.3764C0.209986 4.45881 0.113856 4.57594 0.0570907 4.71299C0.000324965 4.85003 -0.0145275 5.00083 0.0144114 5.14632C0.0433503 5.2918 0.114781 5.42544 0.21967 5.53033C0.32456 5.63522 0.458197 5.70665 0.603683 5.73559C0.749168 5.76453 0.899968 5.74967 1.03701 5.69291C1.17406 5.63614 1.29119 5.54001 1.3736 5.41668C1.45601 5.29334 1.5 5.14834 1.5 5C1.5 4.80109 1.42098 4.61032 1.28033 4.46967C1.13968 4.32902 0.948913 4.25 0.75 4.25ZM0.75 8.25C0.601664 8.25 0.45666 8.29399 0.333323 8.3764C0.209986 8.45881 0.113856 8.57594 0.0570907 8.71299C0.000324965 8.85003 -0.0145275 9.00083 0.0144114 9.14632C0.0433503 9.2918 0.114781 9.42544 0.21967 9.53033C0.32456 9.63522 0.458197 9.70665 0.603683 9.73559C0.749168 9.76453 0.899968 9.74967 1.03701 9.69291C1.17406 9.63614 1.29119 9.54001 1.3736 9.41668C1.45601 9.29334 1.5 9.14834 1.5 9C1.5 8.80109 1.42098 8.61032 1.28033 8.46967C1.13968 8.32902 0.948913 8.25 0.75 8.25Z"
          fill="url(#paint0_linear_1056_25983)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_25983"
            x1="8"
            y1="23.4286"
            x2="27.0053"
            y2="10.3407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF512F" />
            <stop offset="1" stopColor="#F09819" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  secApiNode: {
    colors: colors.web,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M1.5 6.49969H3V10.4997H2C1.86739 10.4997 1.74021 10.5524 1.64645 10.6461C1.55268 10.7399 1.5 10.8671 1.5 10.9997C1.5 11.1323 1.55268 11.2595 1.64645 11.3532C1.74021 11.447 1.86739 11.4997 2 11.4997H14C14.1326 11.4997 14.2598 11.447 14.3536 11.3532C14.4473 11.2595 14.5 11.1323 14.5 10.9997C14.5 10.8671 14.4473 10.7399 14.3536 10.6461C14.2598 10.5524 14.1326 10.4997 14 10.4997H13V6.49969H14.5C14.6088 6.49958 14.7146 6.46399 14.8013 6.39832C14.888 6.33265 14.951 6.24049 14.9806 6.13581C15.0102 6.03112 15.0049 5.91964 14.9654 5.81826C14.9259 5.71689 14.8545 5.63115 14.7619 5.57406L8.26188 1.57406C8.18311 1.52564 8.09246 1.5 8 1.5C7.90754 1.5 7.81689 1.52564 7.73812 1.57406L1.23812 5.57406C1.14552 5.63115 1.07406 5.71689 1.03458 5.81826C0.995107 5.91964 0.989773 6.03112 1.01939 6.13581C1.04901 6.24049 1.11195 6.33265 1.19869 6.39832C1.28542 6.46399 1.39121 6.49958 1.5 6.49969ZM4 6.49969H6V10.4997H4V6.49969ZM9 6.49969V10.4997H7V6.49969H9ZM12 10.4997H10V6.49969H12V10.4997ZM8 2.58656L12.7338 5.49969H3.26625L8 2.58656ZM15.5 12.9997C15.5 13.1323 15.4473 13.2595 15.3536 13.3532C15.2598 13.447 15.1326 13.4997 15 13.4997H1C0.867392 13.4997 0.740215 13.447 0.646447 13.3532C0.552678 13.2595 0.5 13.1323 0.5 12.9997C0.5 12.8671 0.552678 12.7399 0.646447 12.6461C0.740215 12.5524 0.867392 12.4997 1 12.4997H15C15.1326 12.4997 15.2598 12.5524 15.3536 12.6461C15.4473 12.7399 15.5 12.8671 15.5 12.9997Z"
          fill="url(#paint0_linear_1056_24923)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_24923"
            x1="6.61111"
            y1="23.2222"
            x2="26.1111"
            y2="8.77778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F857A6" />
            <stop offset="1" stopColor="#FF5858" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  webAmazon: {
    colors: colors.web,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M15.4997 11.1562V13.2812C15.4997 13.422 15.447 13.5572 15.3533 13.6568C15.2595 13.7564 15.1323 13.8124 14.9997 13.8124C14.8671 13.8124 14.7399 13.7564 14.6461 13.6568C14.5524 13.5572 14.4997 13.422 14.4997 13.2812V12.4385L14.3616 12.5859C14.1678 12.8097 11.8397 15.4062 7.9997 15.4062C4.0722 15.4062 1.72595 12.6895 1.62782 12.5739C1.53914 12.4687 1.49344 12.3303 1.50076 12.1893C1.50809 12.0483 1.56784 11.9161 1.66689 11.8219C1.76593 11.7277 1.89614 11.6791 2.02888 11.6869C2.16162 11.6947 2.28602 11.7581 2.3747 11.8634C2.39157 11.8866 4.53095 14.3437 7.9997 14.3437C11.4684 14.3437 13.6078 11.8866 13.6291 11.8627C13.6344 11.8558 13.64 11.8491 13.6459 11.8428L13.7928 11.6874H12.9997C12.8671 11.6874 12.7399 11.6314 12.6461 11.5318C12.5524 11.4322 12.4997 11.297 12.4997 11.1562C12.4997 11.0153 12.5524 10.8801 12.6461 10.7805C12.7399 10.6809 12.8671 10.6249 12.9997 10.6249H14.9997C15.1323 10.6249 15.2595 10.6809 15.3533 10.7805C15.447 10.8801 15.4997 11.0153 15.4997 11.1562ZM9.9997 6.27729V5.57803C10 5.04087 9.83009 4.51924 9.51727 4.09725C9.20445 3.67526 8.76699 3.37751 8.27542 3.252C7.78385 3.12649 7.26682 3.18054 6.8077 3.40543C6.34857 3.63032 5.97412 4.01295 5.7447 4.49162C5.68436 4.61711 5.57958 4.71199 5.4534 4.75539C5.32723 4.79879 5.18999 4.78716 5.07189 4.72305C4.95378 4.65894 4.86448 4.54761 4.82364 4.41355C4.78279 4.27948 4.79374 4.13367 4.85407 4.00818C5.18561 3.31701 5.72654 2.76458 6.38967 2.43994C7.0528 2.11531 7.7995 2.03738 8.5094 2.21872C9.21931 2.40006 9.85106 2.8301 10.3028 3.43952C10.7546 4.04895 11.0001 4.80226 10.9997 5.57803V11.6874C10.9997 11.8283 10.947 11.9634 10.8533 12.0631C10.7595 12.1627 10.6323 12.2187 10.4997 12.2187C10.3671 12.2187 10.2399 12.1627 10.1461 12.0631C10.0524 11.9634 9.9997 11.8283 9.9997 11.6874V11.2538C9.54036 11.7234 8.96117 12.0391 8.33422 12.1617C7.70728 12.2842 7.06026 12.2081 6.47369 11.9429C5.88712 11.6777 5.38691 11.2351 5.0353 10.6702C4.6837 10.1052 4.49623 9.44284 4.49623 8.76553C4.49623 8.08822 4.6837 7.42587 5.0353 6.8609C5.38691 6.29594 5.88712 5.85331 6.47369 5.58811C7.06026 5.32291 7.70728 5.24685 8.33422 5.36939C8.96117 5.49193 9.54036 5.80766 9.9997 6.27729ZM9.9997 8.76553C9.9997 8.29271 9.86774 7.8305 9.62051 7.43737C9.37327 7.04423 9.02187 6.73782 8.61074 6.55688C8.1996 6.37594 7.7472 6.3286 7.31075 6.42084C6.87429 6.51308 6.47338 6.74077 6.15871 7.0751C5.84404 7.40944 5.62975 7.8354 5.54293 8.29914C5.45611 8.76288 5.50067 9.24355 5.67097 9.68038C5.84127 10.1172 6.12966 10.4906 6.49967 10.7533C6.86968 11.0159 7.30469 11.1562 7.7497 11.1562C8.04517 11.1562 8.33775 11.0943 8.61074 10.9742C8.88372 10.854 9.13176 10.6779 9.34069 10.456C9.54962 10.234 9.71535 9.97042 9.82843 9.68038C9.9415 9.39034 9.9997 9.07947 9.9997 8.76553Z"
          fill="url(#paint0_linear_1056_24923)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_24923"
            x1="6.61111"
            y1="23.2222"
            x2="26.1111"
            y2="8.77778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F857A6" />
            <stop offset="1" stopColor="#FF5858" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  storedDataCaller: {
    colors: colors.data,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 256 256"
      >
        <path
          d="M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM40,112H80v32H40Zm56,0H216v32H96ZM216,64V96H40V64ZM40,160H80v32H40Zm176,32H96V160H216v32Z"
          fill="url(#paint0_linear_1056_25983)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_25983"
            x1="8"
            y1="23.4286"
            x2="27.0053"
            y2="10.3407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF512F" />
            <stop offset="1" stopColor="#F09819" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  fileSave: {
    colors: colors.data,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 13 12"
        fill="none"
      >
        <path
          d="M13 0.5V11.5C13 11.6326 12.9473 11.7598 12.8536 11.8536C12.7598 11.9473 12.6326 12 12.5 12C12.3674 12 12.2402 11.9473 12.1464 11.8536C12.0527 11.7598 12 11.6326 12 11.5V0.5C12 0.367392 12.0527 0.240215 12.1464 0.146447C12.2402 0.0526785 12.3674 0 12.5 0C12.6326 0 12.7598 0.0526785 12.8536 0.146447C12.9473 0.240215 13 0.367392 13 0.5ZM11 2V4.5C11 4.76522 10.8946 5.01957 10.7071 5.20711C10.5196 5.39464 10.2652 5.5 10 5.5H4C3.73478 5.5 3.48043 5.39464 3.29289 5.20711C3.10536 5.01957 3 4.76522 3 4.5V2C3 1.73478 3.10536 1.48043 3.29289 1.29289C3.48043 1.10536 3.73478 1 4 1H10C10.2652 1 10.5196 1.10536 10.7071 1.29289C10.8946 1.48043 11 1.73478 11 2ZM10 2H4V4.5H10V2ZM11 7.5V10C11 10.2652 10.8946 10.5196 10.7071 10.7071C10.5196 10.8946 10.2652 11 10 11H1.5C1.23478 11 0.98043 10.8946 0.792893 10.7071C0.605357 10.5196 0.5 10.2652 0.5 10V7.5C0.5 7.23478 0.605357 6.98043 0.792893 6.79289C0.98043 6.60536 1.23478 6.5 1.5 6.5H10C10.2652 6.5 10.5196 6.60536 10.7071 6.79289C10.8946 6.98043 11 7.23478 11 7.5ZM10 7.5H1.5V10H10V7.5Z"
          fill="url(#paint0_linear_1056_25983)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_25983"
            x1="8"
            y1="23.4286"
            x2="27.0053"
            y2="10.3407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF512F" />
            <stop offset="1" stopColor="#F09819" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  pullData: {
    colors: colors.data,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 13 12"
        fill="none"
      >
        <path
          d="M13 0.5V11.5C13 11.6326 12.9473 11.7598 12.8536 11.8536C12.7598 11.9473 12.6326 12 12.5 12C12.3674 12 12.2402 11.9473 12.1464 11.8536C12.0527 11.7598 12 11.6326 12 11.5V0.5C12 0.367392 12.0527 0.240215 12.1464 0.146447C12.2402 0.0526785 12.3674 0 12.5 0C12.6326 0 12.7598 0.0526785 12.8536 0.146447C12.9473 0.240215 13 0.367392 13 0.5ZM11 2V4.5C11 4.76522 10.8946 5.01957 10.7071 5.20711C10.5196 5.39464 10.2652 5.5 10 5.5H4C3.73478 5.5 3.48043 5.39464 3.29289 5.20711C3.10536 5.01957 3 4.76522 3 4.5V2C3 1.73478 3.10536 1.48043 3.29289 1.29289C3.48043 1.10536 3.73478 1 4 1H10C10.2652 1 10.5196 1.10536 10.7071 1.29289C10.8946 1.48043 11 1.73478 11 2ZM10 2H4V4.5H10V2ZM11 7.5V10C11 10.2652 10.8946 10.5196 10.7071 10.7071C10.5196 10.8946 10.2652 11 10 11H1.5C1.23478 11 0.98043 10.8946 0.792893 10.7071C0.605357 10.5196 0.5 10.2652 0.5 10V7.5C0.5 7.23478 0.605357 6.98043 0.792893 6.79289C0.98043 6.60536 1.23478 6.5 1.5 6.5H10C10.2652 6.5 10.5196 6.60536 10.7071 6.79289C10.8946 6.98043 11 7.23478 11 7.5ZM10 7.5H1.5V10H10V7.5Z"
          fill="url(#paint0_linear_1056_25983)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_25983"
            x1="8"
            y1="23.4286"
            x2="27.0053"
            y2="10.3407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF512F" />
            <stop offset="1" stopColor="#F09819" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  pushData: {
    colors: colors.data,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M3 2.5V13.5C3 13.6326 2.94732 13.7598 2.85355 13.8536C2.75979 13.9473 2.63261 14 2.5 14C2.36739 14 2.24021 13.9473 2.14645 13.8536C2.05268 13.7598 2 13.6326 2 13.5V2.5C2 2.36739 2.05268 2.24021 2.14645 2.14645C2.24021 2.05268 2.36739 2 2.5 2C2.63261 2 2.75979 2.05268 2.85355 2.14645C2.94732 2.24021 3 2.36739 3 2.5ZM4 6.5V4C4 3.73478 4.10536 3.48043 4.29289 3.29289C4.48043 3.10536 4.73478 3 5 3H11C11.2652 3 11.5196 3.10536 11.7071 3.29289C11.8946 3.48043 12 3.73478 12 4V6.5C12 6.76522 11.8946 7.01957 11.7071 7.20711C11.5196 7.39464 11.2652 7.5 11 7.5H5C4.73478 7.5 4.48043 7.39464 4.29289 7.20711C4.10536 7.01957 4 6.76522 4 6.5ZM5 6.5H11V4H5V6.5ZM14.5 9.5V12C14.5 12.2652 14.3946 12.5196 14.2071 12.7071C14.0196 12.8946 13.7652 13 13.5 13H5C4.73478 13 4.48043 12.8946 4.29289 12.7071C4.10536 12.5196 4 12.2652 4 12V9.5C4 9.23478 4.10536 8.98043 4.29289 8.79289C4.48043 8.60536 4.73478 8.5 5 8.5H13.5C13.7652 8.5 14.0196 8.60536 14.2071 8.79289C14.3946 8.98043 14.5 9.23478 14.5 9.5ZM13.5 12V9.5H5V12H13.5Z"
          fill="url(#paint0_linear_1056_25983)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_25983"
            x1="8"
            y1="23.4286"
            x2="27.0053"
            y2="10.3407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF512F" />
            <stop offset="1" stopColor="#F09819" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  sqlQuerier: {
    colors: colors.data,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 12 13"
        fill="none"
      >
        <path
          d="M6 0C2.6356 0 0 1.5375 0 3.5V9.5C0 11.4625 2.6356 13 6 13S12 11.4625 12 9.5V3.5C12 1.5375 9.3644 0 6 0ZM11 6.5C11 7.1013 10.5075 7.7144 9.6494 8.1825 8.6831 8.7094 7.3869 9 6 9S3.3169 8.7094 2.3506 8.1825C1.4925 7.7144 1 7.1013 1 6.5V5.46C2.0663 6.3975 3.8894 7 6 7S9.9337 6.395 11 5.46ZM2.3506 1.8175C3.3169 1.2906 4.6131 1 6 1S8.6831 1.2906 9.6494 1.8175C10.5075 2.2856 11 2.8987 11 3.5S10.5075 4.7144 9.6494 5.1825C8.6831 5.7094 7.3869 6 6 6S3.3169 5.7094 2.3506 5.1825C1.4925 4.7144 1 4.1013 1 3.5S1.4925 2.2856 2.3506 1.8175ZM9.6494 11.1825C8.6831 11.7094 7.3869 12 6 12S3.3169 11.7094 2.3506 11.1825C1.4925 10.7144 1 10.1012 1 9.5V8.46C2.0663 9.3975 3.8894 10 6 10S9.9337 9.395 11 8.46V9.5C11 10.1012 10.5075 10.7144 9.6494 11.1825Z"
          fill="url(#paint0_linear_1056_25983)"
        ></path>
        <defs>
          <linearGradient
            id="paint0_linear_1056_25983"
            x1="8"
            y1="23.4286"
            x2="27.0053"
            y2="10.3407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF512F" />
            <stop offset="1" stopColor="#F09819" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  hubSpotCRM: {
    colors: colors.data,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 13 12"
        fill="none"
      >
        <path
          d="M13 0.5V11.5C13 11.6326 12.9473 11.7598 12.8536 11.8536C12.7598 11.9473 12.6326 12 12.5 12C12.3674 12 12.2402 11.9473 12.1464 11.8536C12.0527 11.7598 12 11.6326 12 11.5V0.5C12 0.367392 12.0527 0.240215 12.1464 0.146447C12.2402 0.0526785 12.3674 0 12.5 0C12.6326 0 12.7598 0.0526785 12.8536 0.146447C12.9473 0.240215 13 0.367392 13 0.5ZM11 2V4.5C11 4.76522 10.8946 5.01957 10.7071 5.20711C10.5196 5.39464 10.2652 5.5 10 5.5H4C3.73478 5.5 3.48043 5.39464 3.29289 5.20711C3.10536 5.01957 3 4.76522 3 4.5V2C3 1.73478 3.10536 1.48043 3.29289 1.29289C3.48043 1.10536 3.73478 1 4 1H10C10.2652 1 10.5196 1.10536 10.7071 1.29289C10.8946 1.48043 11 1.73478 11 2ZM10 2H4V4.5H10V2ZM11 7.5V10C11 10.2652 10.8946 10.5196 10.7071 10.7071C10.5196 10.8946 10.2652 11 10 11H1.5C1.23478 11 0.98043 10.8946 0.792893 10.7071C0.605357 10.5196 0.5 10.2652 0.5 10V7.5C0.5 7.23478 0.605357 6.98043 0.792893 6.79289C0.98043 6.60536 1.23478 6.5 1.5 6.5H10C10.2652 6.5 10.5196 6.60536 10.7071 6.79289C10.8946 6.98043 11 7.23478 11 7.5ZM10 7.5H1.5V10H10V7.5Z"
          fill="url(#paint0_linear_1056_25983)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1056_25983"
            x1="8"
            y1="23.4286"
            x2="27.0053"
            y2="10.3407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF512F" />
            <stop offset="1" stopColor="#F09819" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  thirdPartyIntegration: {
    colors: colors.external,
    nodeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
          fill="url(#paint0_linear_third_party)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_third_party"
            x1="2"
            y1="12"
            x2="22"
            y2="12"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FD746C" />
            <stop offset="0.5" stopColor="#FE846A" />
            <stop offset="1" stopColor="#FF9068" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
};

export { colors, nodeColorBasedOnType };
